/**
 * GENERATED by tools/process-art.mjs - do not edit by hand.
 *
 * Photographic art: unit portraits, resource renders and village backdrops.
 * The pixel-art sprite sheet lives in ../sprites/manifest.ts instead.
 */

import a_units_spearman_webp from './units/spearman.webp';
import a_units_swordsman_webp from './units/swordsman.webp';
import a_units_axeman_webp from './units/axeman.webp';
import a_units_militia_archer_webp from './units/militia_archer.webp';
import a_units_archer_webp from './units/archer.webp';
import a_units_crossbowman_webp from './units/crossbowman.webp';
import a_units_scout_webp from './units/scout.webp';
import a_units_light_cavalry_webp from './units/light_cavalry.webp';
import a_units_heavy_cavalry_webp from './units/heavy_cavalry.webp';
import a_units_knight_webp from './units/knight.webp';
import a_units_ram_webp from './units/ram.webp';
import a_units_catapult_webp from './units/catapult.webp';
import a_units_bailiff_webp from './units/bailiff.webp';
import a_units_cannon_webp from './units/cannon.webp';
import a_units_cog_webp from './units/cog.webp';
import a_units_longship_webp from './units/longship.webp';
import a_units_war_galley_webp from './units/war_galley.webp';
import a_units_spearman_thumb_webp from './units/spearman-thumb.webp';
import a_units_swordsman_thumb_webp from './units/swordsman-thumb.webp';
import a_units_axeman_thumb_webp from './units/axeman-thumb.webp';
import a_units_militia_archer_thumb_webp from './units/militia_archer-thumb.webp';
import a_units_archer_thumb_webp from './units/archer-thumb.webp';
import a_units_crossbowman_thumb_webp from './units/crossbowman-thumb.webp';
import a_units_scout_thumb_webp from './units/scout-thumb.webp';
import a_units_light_cavalry_thumb_webp from './units/light_cavalry-thumb.webp';
import a_units_heavy_cavalry_thumb_webp from './units/heavy_cavalry-thumb.webp';
import a_units_knight_thumb_webp from './units/knight-thumb.webp';
import a_units_ram_thumb_webp from './units/ram-thumb.webp';
import a_units_catapult_thumb_webp from './units/catapult-thumb.webp';
import a_units_bailiff_thumb_webp from './units/bailiff-thumb.webp';
import a_units_cannon_thumb_webp from './units/cannon-thumb.webp';
import a_units_cog_thumb_webp from './units/cog-thumb.webp';
import a_units_longship_thumb_webp from './units/longship-thumb.webp';
import a_units_war_galley_thumb_webp from './units/war_galley-thumb.webp';
import a_resources_wood_webp from './resources/wood.webp';
import a_resources_clay_webp from './resources/clay.webp';
import a_resources_iron_webp from './resources/iron.webp';
import a_resources_grain_webp from './resources/grain.webp';
import a_resources_population_webp from './resources/population.webp';
import a_backdrops_open_jpg from './backdrops/open.jpg';
import a_backdrops_palisade_jpg from './backdrops/palisade.jpg';
import a_backdrops_stonewall_jpg from './backdrops/stonewall.jpg';
import a_backdrops_shoreOpen_jpg from './backdrops/shoreOpen.jpg';
import a_backdrops_shorePalisade_jpg from './backdrops/shorePalisade.jpg';
import a_village_tiers_tier_1_webp from './village-tiers/tier-1.webp';
import a_village_tiers_tier_2_webp from './village-tiers/tier-2.webp';
import a_village_tiers_tier_3_webp from './village-tiers/tier-3.webp';
import a_village_tiers_tier_4_webp from './village-tiers/tier-4.webp';
import a_village_tiers_tier_5_webp from './village-tiers/tier-5.webp';
import a_village_tiers_tier_6_webp from './village-tiers/tier-6.webp';
import a_village_tiers_tier_7_webp from './village-tiers/tier-7.webp';
import a_village_tiers_tier_arabic_1_webp from './village-tiers/tier-arabic-1.webp';
import a_village_tiers_tier_arabic_2_webp from './village-tiers/tier-arabic-2.webp';
import a_village_tiers_tier_arabic_3_webp from './village-tiers/tier-arabic-3.webp';
import a_village_tiers_tier_arabic_4_webp from './village-tiers/tier-arabic-4.webp';
import a_village_tiers_tier_arabic_5_webp from './village-tiers/tier-arabic-5.webp';
import a_village_tiers_tier_arabic_6_webp from './village-tiers/tier-arabic-6.webp';
import a_village_tiers_tier_arabic_7_webp from './village-tiers/tier-arabic-7.webp';
import a_pages_landing_webp from './pages/landing.webp';
import a_pages_logo_webp from './pages/logo.webp';
import a_pages_wordmark_webp from './pages/wordmark.webp';
import a_pages_tutor_webp from './pages/tutor.webp';
import a_pages_reportSiege_webp from './pages/reportSiege.webp';
import a_pages_reportCamp_webp from './pages/reportCamp.webp';
import a_pages_reportScout_webp from './pages/reportScout.webp';
import a_pages_sidePanel_webp from './pages/sidePanel.webp';
import a_map_plains_webp from './map/plains.webp';
import a_map_desert_webp from './map/desert.webp';
import a_map_forest_webp from './map/forest.webp';
import a_map_hills_webp from './map/hills.webp';
import a_map_mountain_webp from './map/mountain.webp';
import a_map_ocean_webp from './map/ocean.webp';
import a_map_shallows_webp from './map/shallows.webp';
import a_map_forest_overlay_webp from './map/forest-overlay.webp';
import a_map_cloud_0_webp from './map/cloud-0.webp';
import a_map_cloud_1_webp from './map/cloud-1.webp';
import a_map_cloud_2_webp from './map/cloud-2.webp';
import a_map_cloud_3_webp from './map/cloud-3.webp';
import a_map_cloud_4_webp from './map/cloud-4.webp';
import a_map_cloud_5_webp from './map/cloud-5.webp';
import a_map_mountain_0_webp from './map/mountain-0.webp';
import a_map_mountain_1_webp from './map/mountain-1.webp';
import a_ui_points_webp from './ui/points.webp';
import a_ui_loyalty_webp from './ui/loyalty.webp';
import a_ui_alliance_webp from './ui/alliance.webp';
import a_ui_military_webp from './ui/military.webp';
import a_ui_market_webp from './ui/market.webp';
import a_ui_reports_webp from './ui/reports.webp';
import a_ui_buildings_webp from './ui/buildings.webp';
import a_ui_world_webp from './ui/world.webp';
import a_ui_scroll_webp from './ui/scroll.webp';
import a_ui_forum_webp from './ui/forum.webp';
import a_ui_gold_webp from './ui/gold.webp';
import a_ui_orderAttack_webp from './ui/orderAttack.webp';
import a_ui_orderRaid_webp from './ui/orderRaid.webp';
import a_ui_orderSupport_webp from './ui/orderSupport.webp';
import a_ui_orderScout_webp from './ui/orderScout.webp';
import a_ui_orderRecall_webp from './ui/orderRecall.webp';
import a_ui_orderEnter_webp from './ui/orderEnter.webp';
import a_ui_orderClear_webp from './ui/orderClear.webp';
import a_ui_reportBattle_webp from './ui/reportBattle.webp';
import a_ui_reportScouting_webp from './ui/reportScouting.webp';
import a_ui_reportRaid_webp from './ui/reportRaid.webp';
import a_ui_domain_webp from './ui/domain.webp';
import a_ui_prestige_webp from './ui/prestige.webp';
import a_ui_portrait_webp from './ui/portrait.webp';
import a_ui_letters_webp from './ui/letters.webp';
import a_ui_settings_webp from './ui/settings.webp';
import a_map_markers_banditCamp_webp from './map-markers/banditCamp.webp';
import a_crests_county_webp from './crests/county.webp';
import a_crests_duchy_webp from './crests/duchy.webp';
import a_crests_kingdom_webp from './crests/kingdom.webp';
import a_crests_empire_webp from './crests/empire.webp';
import a_research_three_field_webp from './research/three_field.webp';
import a_research_drill_yards_webp from './research/drill_yards.webp';
import a_research_chancery_webp from './research/chancery.webp';
import a_research_master_masons_webp from './research/master_masons.webp';
import a_research_muster_rolls_webp from './research/muster_rolls.webp';
import a_research_heralds_webp from './research/heralds.webp';
import a_research_deep_mines_webp from './research/deep_mines.webp';
import a_research_armouries_webp from './research/armouries.webp';
import a_research_vassal_courts_webp from './research/vassal_courts.webp';
import a_research_crown_works_webp from './research/crown_works.webp';
import a_research_veteran_cadres_webp from './research/veteran_cadres.webp';
import a_research_imperial_chancery_webp from './research/imperial_chancery.webp';
import a_field_infantry_webp from './field/infantry.webp';
import a_field_cavalry_webp from './field/cavalry.webp';
import a_field_horseArcher_webp from './field/horseArcher.webp';
import a_field_captain_webp from './field/captain.webp';
import a_field_heavy_webp from './field/heavy.webp';
import a_field_archer_webp from './field/archer.webp';
import a_field_cannon_webp from './field/cannon.webp';
import a_field_catapult_webp from './field/catapult.webp';
import a_field_ram_webp from './field/ram.webp';
import a_preset_swords_webp from './preset/swords.webp';
import a_preset_shield_webp from './preset/shield.webp';
import a_preset_torch_webp from './preset/torch.webp';
import a_preset_horse_webp from './preset/horse.webp';
import a_preset_bow_webp from './preset/bow.webp';
import a_preset_ram_webp from './preset/ram.webp';
import a_preset_crown_webp from './preset/crown.webp';
import a_preset_skull_webp from './preset/skull.webp';
import a_preset_wheat_webp from './preset/wheat.webp';
import a_preset_ship_webp from './preset/ship.webp';
import a_preset_tower_webp from './preset/tower.webp';
import a_preset_spear_webp from './preset/spear.webp';
import a_preset_horn_webp from './preset/horn.webp';
import a_preset_wolf_webp from './preset/wolf.webp';
import a_preset_hourglass_webp from './preset/hourglass.webp';
import a_preset_pennant_webp from './preset/pennant.webp';
import a_task_first_timber_webp from './task/first-timber.webp';
import a_task_clay_and_iron_webp from './task/clay-and-iron.webp';
import a_task_iron_in_the_hills_webp from './task/iron-in-the-hills.webp';
import a_task_feed_them_webp from './task/feed-them.webp';
import a_task_somewhere_to_put_it_webp from './task/somewhere-to-put-it.webp';
import a_task_seat_of_the_lord_webp from './task/seat-of-the-lord.webp';
import a_task_raise_a_guard_webp from './task/raise-a-guard.webp';
import a_task_first_blood_webp from './task/first-blood.webp';
import a_task_a_standing_army_webp from './task/a-standing-army.webp';
import a_task_stone_on_stone_webp from './task/stone-on-stone.webp';
import a_task_three_camps_webp from './task/three-camps.webp';
import a_task_find_friends_webp from './task/find-friends.webp';
import a_task_a_place_of_note_webp from './task/a-place-of-note.webp';
import a_notify_scroll_webp from './notify/scroll.webp';
import a_notify_battle_webp from './notify/battle.webp';
import a_notify_shield_webp from './notify/shield.webp';
import a_notify_castle_webp from './notify/castle.webp';
import a_notify_letter_webp from './notify/letter.webp';
import a_notify_horn_webp from './notify/horn.webp';
import a_notify_grain_webp from './notify/grain.webp';
import a_notify_alert_webp from './notify/alert.webp';
import a_heraldry_kingdom_k_portugal_webp from './heraldry/kingdom-k-portugal.webp';
import a_heraldry_kingdom_k_leon_webp from './heraldry/kingdom-k-leon.webp';
import a_heraldry_kingdom_k_castile_webp from './heraldry/kingdom-k-castile.webp';
import a_heraldry_kingdom_k_navarre_webp from './heraldry/kingdom-k-navarre.webp';
import a_heraldry_kingdom_k_aragon_webp from './heraldry/kingdom-k-aragon.webp';
import a_heraldry_kingdom_k_andalusia_webp from './heraldry/kingdom-k-andalusia.webp';
import a_heraldry_kingdom_k_valencia_webp from './heraldry/kingdom-k-valencia.webp';
import a_heraldry_kingdom_k_morocco_webp from './heraldry/kingdom-k-morocco.webp';
import a_heraldry_kingdom_k_tlemcen_webp from './heraldry/kingdom-k-tlemcen.webp';
import a_heraldry_kingdom_k_ifriqiya_webp from './heraldry/kingdom-k-ifriqiya.webp';
import a_heraldry_kingdom_k_france_webp from './heraldry/kingdom-k-france.webp';
import a_heraldry_kingdom_k_occitania_webp from './heraldry/kingdom-k-occitania.webp';
import a_heraldry_kingdom_k_england_webp from './heraldry/kingdom-k-england.webp';
import a_heraldry_kingdom_k_ireland_webp from './heraldry/kingdom-k-ireland.webp';
import a_heraldry_kingdom_k_aquitaine_webp from './heraldry/kingdom-k-aquitaine.webp';
import a_heraldry_kingdom_k_scotland_webp from './heraldry/kingdom-k-scotland.webp';
import a_heraldry_kingdom_k_norway_webp from './heraldry/kingdom-k-norway.webp';
import a_heraldry_kingdom_k_sweden_webp from './heraldry/kingdom-k-sweden.webp';
import a_heraldry_kingdom_k_denmark_webp from './heraldry/kingdom-k-denmark.webp';
import a_heraldry_kingdom_k_germany_webp from './heraldry/kingdom-k-germany.webp';
import a_heraldry_kingdom_k_burgundy_webp from './heraldry/kingdom-k-burgundy.webp';
import a_heraldry_kingdom_k_bohemia_webp from './heraldry/kingdom-k-bohemia.webp';
import a_heraldry_kingdom_k_italy_webp from './heraldry/kingdom-k-italy.webp';
import a_heraldry_kingdom_k_venice_webp from './heraldry/kingdom-k-venice.webp';
import a_heraldry_kingdom_k_papal_webp from './heraldry/kingdom-k-papal.webp';
import a_heraldry_kingdom_k_sicily_webp from './heraldry/kingdom-k-sicily.webp';
import a_heraldry_kingdom_k_hungary_webp from './heraldry/kingdom-k-hungary.webp';
import a_heraldry_kingdom_k_poland_webp from './heraldry/kingdom-k-poland.webp';
import a_heraldry_kingdom_k_livonia_webp from './heraldry/kingdom-k-livonia.webp';
import a_heraldry_kingdom_k_novgorod_webp from './heraldry/kingdom-k-novgorod.webp';
import a_heraldry_kingdom_k_vladimir_webp from './heraldry/kingdom-k-vladimir.webp';
import a_heraldry_kingdom_k_kyiv_webp from './heraldry/kingdom-k-kyiv.webp';
import a_heraldry_kingdom_k_galicia_webp from './heraldry/kingdom-k-galicia.webp';
import a_heraldry_kingdom_k_bulgaria_webp from './heraldry/kingdom-k-bulgaria.webp';
import a_heraldry_kingdom_k_serbia_webp from './heraldry/kingdom-k-serbia.webp';
import a_heraldry_kingdom_k_thrace_webp from './heraldry/kingdom-k-thrace.webp';
import a_heraldry_kingdom_k_thessalonica_webp from './heraldry/kingdom-k-thessalonica.webp';
import a_heraldry_kingdom_k_achaea_webp from './heraldry/kingdom-k-achaea.webp';
import a_heraldry_kingdom_k_epirus_webp from './heraldry/kingdom-k-epirus.webp';
import a_heraldry_kingdom_k_nicaea_webp from './heraldry/kingdom-k-nicaea.webp';
import a_heraldry_kingdom_k_trebizond_webp from './heraldry/kingdom-k-trebizond.webp';
import a_heraldry_kingdom_k_rum_webp from './heraldry/kingdom-k-rum.webp';
import a_heraldry_kingdom_k_cilicia_webp from './heraldry/kingdom-k-cilicia.webp';
import a_heraldry_kingdom_k_cyprus_webp from './heraldry/kingdom-k-cyprus.webp';
import a_heraldry_kingdom_k_georgia_webp from './heraldry/kingdom-k-georgia.webp';
import a_heraldry_kingdom_k_antioch_webp from './heraldry/kingdom-k-antioch.webp';
import a_heraldry_kingdom_k_jerusalem_webp from './heraldry/kingdom-k-jerusalem.webp';
import a_heraldry_kingdom_k_egypt_webp from './heraldry/kingdom-k-egypt.webp';
import a_heraldry_kingdom_k_baghdad_webp from './heraldry/kingdom-k-baghdad.webp';
import a_heraldry_kingdom_k_mosul_webp from './heraldry/kingdom-k-mosul.webp';
import a_heraldry_kingdom_k_mardin_webp from './heraldry/kingdom-k-mardin.webp';
import a_heraldry_kingdom_k_azerbaijan_webp from './heraldry/kingdom-k-azerbaijan.webp';
import a_heraldry_duchy_duchy_of_estremadura_webp from './heraldry/duchy-duchy-of-estremadura.webp';
import a_heraldry_duchy_duchy_of_portucale_webp from './heraldry/duchy-duchy-of-portucale.webp';
import a_heraldry_duchy_duchy_of_galicia_webp from './heraldry/duchy-duchy-of-galicia.webp';
import a_heraldry_duchy_duchy_of_toledo_webp from './heraldry/duchy-duchy-of-toledo.webp';
import a_heraldry_duchy_duchy_of_castile_webp from './heraldry/duchy-duchy-of-castile.webp';
import a_heraldry_duchy_duchy_of_catalonia_webp from './heraldry/duchy-duchy-of-catalonia.webp';
import a_heraldry_duchy_duchy_of_aragon_webp from './heraldry/duchy-duchy-of-aragon.webp';
import a_heraldry_duchy_duchy_of_andalusia_webp from './heraldry/duchy-duchy-of-andalusia.webp';
import a_heraldry_duchy_duchy_of_marchena_webp from './heraldry/duchy-duchy-of-marchena.webp';
import a_heraldry_duchy_duchy_of_fez_webp from './heraldry/duchy-duchy-of-fez.webp';
import a_heraldry_duchy_duchy_of_bejaia_webp from './heraldry/duchy-duchy-of-bejaia.webp';
import a_heraldry_duchy_duchy_of_ifriqiya_webp from './heraldry/duchy-duchy-of-ifriqiya.webp';
import a_heraldry_duchy_duchy_of_marrakech_webp from './heraldry/duchy-duchy-of-marrakech.webp';
import a_heraldry_duchy_duchy_of_alcida_webp from './heraldry/duchy-duchy-of-alcida.webp';
import a_heraldry_duchy_duchy_of_tlemcen_webp from './heraldry/duchy-duchy-of-tlemcen.webp';
import a_heraldry_duchy_duchy_of_tripolitania_webp from './heraldry/duchy-duchy-of-tripolitania.webp';
import a_heraldry_duchy_duchy_of_the_ile_de_france_webp from './heraldry/duchy-duchy-of-the-ile-de-france.webp';
import a_heraldry_duchy_county_of_anjou_webp from './heraldry/duchy-county-of-anjou.webp';
import a_heraldry_duchy_county_of_flanders_webp from './heraldry/duchy-county-of-flanders.webp';
import a_heraldry_duchy_duchy_of_brittany_webp from './heraldry/duchy-duchy-of-brittany.webp';
import a_heraldry_duchy_duchy_of_essex_webp from './heraldry/duchy-duchy-of-essex.webp';
import a_heraldry_duchy_duchy_of_northumbria_webp from './heraldry/duchy-duchy-of-northumbria.webp';
import a_heraldry_duchy_duchy_of_elmsett_webp from './heraldry/duchy-duchy-of-elmsett.webp';
import a_heraldry_duchy_duchy_of_leinster_webp from './heraldry/duchy-duchy-of-leinster.webp';
import a_heraldry_duchy_duchy_of_gascony_webp from './heraldry/duchy-duchy-of-gascony.webp';
import a_heraldry_duchy_duchy_of_lothian_webp from './heraldry/duchy-duchy-of-lothian.webp';
import a_heraldry_duchy_duchy_of_gulathing_webp from './heraldry/duchy-duchy-of-gulathing.webp';
import a_heraldry_duchy_duchy_of_trondelag_webp from './heraldry/duchy-duchy-of-trondelag.webp';
import a_heraldry_duchy_duchy_of_viken_webp from './heraldry/duchy-duchy-of-viken.webp';
import a_heraldry_duchy_duchy_of_uppland_webp from './heraldry/duchy-duchy-of-uppland.webp';
import a_heraldry_duchy_duchy_of_vastergotland_webp from './heraldry/duchy-duchy-of-vastergotland.webp';
import a_heraldry_duchy_duchy_of_gotland_webp from './heraldry/duchy-duchy-of-gotland.webp';
import a_heraldry_duchy_duchy_of_zealand_webp from './heraldry/duchy-duchy-of-zealand.webp';
import a_heraldry_duchy_duchy_of_falund_webp from './heraldry/duchy-duchy-of-falund.webp';
import a_heraldry_duchy_duchy_of_jutland_webp from './heraldry/duchy-duchy-of-jutland.webp';
import a_heraldry_duchy_duchy_of_holstein_webp from './heraldry/duchy-duchy-of-holstein.webp';
import a_heraldry_duchy_duchy_of_lower_lorraine_webp from './heraldry/duchy-duchy-of-lower-lorraine.webp';
import a_heraldry_duchy_duchy_of_cranbach_webp from './heraldry/duchy-duchy-of-cranbach.webp';
import a_heraldry_duchy_landgraviate_of_alsace_webp from './heraldry/duchy-landgraviate-of-alsace.webp';
import a_heraldry_duchy_duchy_of_bavaria_webp from './heraldry/duchy-duchy-of-bavaria.webp';
import a_heraldry_duchy_duchy_of_saxony_webp from './heraldry/duchy-duchy-of-saxony.webp';
import a_heraldry_duchy_duchy_of_saynfurt_webp from './heraldry/duchy-duchy-of-saynfurt.webp';
import a_heraldry_duchy_county_of_burgundy_webp from './heraldry/duchy-county-of-burgundy.webp';
import a_heraldry_duchy_duchy_of_lyonnais_webp from './heraldry/duchy-duchy-of-lyonnais.webp';
import a_heraldry_duchy_county_of_provence_webp from './heraldry/duchy-county-of-provence.webp';
import a_heraldry_duchy_duchy_of_lobau_webp from './heraldry/duchy-duchy-of-lobau.webp';
import a_heraldry_duchy_duchy_of_lombardy_webp from './heraldry/duchy-duchy-of-lombardy.webp';
import a_heraldry_duchy_duchy_of_tuscany_webp from './heraldry/duchy-duchy-of-tuscany.webp';
import a_heraldry_duchy_judicate_of_cagliari_webp from './heraldry/duchy-judicate-of-cagliari.webp';
import a_heraldry_duchy_duchy_of_venetia_webp from './heraldry/duchy-duchy-of-venetia.webp';
import a_heraldry_duchy_duchy_of_dalmatia_webp from './heraldry/duchy-duchy-of-dalmatia.webp';
import a_heraldry_duchy_duchy_of_crete_webp from './heraldry/duchy-duchy-of-crete.webp';
import a_heraldry_duchy_duchy_of_sicily_webp from './heraldry/duchy-duchy-of-sicily.webp';
import a_heraldry_duchy_duchy_of_bari_webp from './heraldry/duchy-duchy-of-bari.webp';
import a_heraldry_duchy_duchy_of_hungary_webp from './heraldry/duchy-duchy-of-hungary.webp';
import a_heraldry_duchy_duchy_of_croatia_webp from './heraldry/duchy-duchy-of-croatia.webp';
import a_heraldry_duchy_duchy_of_lesser_poland_webp from './heraldry/duchy-duchy-of-lesser-poland.webp';
import a_heraldry_duchy_duchy_of_greater_poland_webp from './heraldry/duchy-duchy-of-greater-poland.webp';
import a_heraldry_duchy_duchy_of_pomerelia_webp from './heraldry/duchy-duchy-of-pomerelia.webp';
import a_heraldry_duchy_duchy_of_lithuania_webp from './heraldry/duchy-duchy-of-lithuania.webp';
import a_heraldry_duchy_duchy_of_livonia_webp from './heraldry/duchy-duchy-of-livonia.webp';
import a_heraldry_duchy_duchy_of_novgorod_webp from './heraldry/duchy-duchy-of-novgorod.webp';
import a_heraldry_duchy_duchy_of_pskov_webp from './heraldry/duchy-duchy-of-pskov.webp';
import a_heraldry_duchy_duchy_of_vladimir_webp from './heraldry/duchy-duchy-of-vladimir.webp';
import a_heraldry_duchy_duchy_of_moscow_webp from './heraldry/duchy-duchy-of-moscow.webp';
import a_heraldry_duchy_duchy_of_kyiv_webp from './heraldry/duchy-duchy-of-kyiv.webp';
import a_heraldry_duchy_duchy_of_falkstein_webp from './heraldry/duchy-duchy-of-falkstein.webp';
import a_heraldry_duchy_duchy_of_smolensk_webp from './heraldry/duchy-duchy-of-smolensk.webp';
import a_heraldry_duchy_duchy_of_polotsk_webp from './heraldry/duchy-duchy-of-polotsk.webp';
import a_heraldry_duchy_duchy_of_halych_webp from './heraldry/duchy-duchy-of-halych.webp';
import a_heraldry_duchy_duchy_of_volhynia_webp from './heraldry/duchy-duchy-of-volhynia.webp';
import a_heraldry_duchy_duchy_of_tarnovo_webp from './heraldry/duchy-duchy-of-tarnovo.webp';
import a_heraldry_duchy_duchy_of_vidin_webp from './heraldry/duchy-duchy-of-vidin.webp';
import a_heraldry_duchy_duchy_of_kosovo_webp from './heraldry/duchy-duchy-of-kosovo.webp';
import a_heraldry_duchy_duchy_of_thrace_webp from './heraldry/duchy-duchy-of-thrace.webp';
import a_heraldry_duchy_duchy_of_lamos_webp from './heraldry/duchy-duchy-of-lamos.webp';
import a_heraldry_duchy_duchy_of_ionia_webp from './heraldry/duchy-duchy-of-ionia.webp';
import a_heraldry_duchy_duchy_of_chaldia_webp from './heraldry/duchy-duchy-of-chaldia.webp';
import a_heraldry_duchy_duchy_of_paphlagonia_webp from './heraldry/duchy-duchy-of-paphlagonia.webp';
import a_heraldry_duchy_duchy_of_ikonion_webp from './heraldry/duchy-duchy-of-ikonion.webp';
import a_heraldry_duchy_duchy_of_sebasteia_webp from './heraldry/duchy-duchy-of-sebasteia.webp';
import a_heraldry_duchy_duchy_of_ankyra_webp from './heraldry/duchy-duchy-of-ankyra.webp';
import a_heraldry_duchy_duchy_of_loritino_webp from './heraldry/duchy-duchy-of-loritino.webp';
import a_heraldry_duchy_duchy_of_kartli_webp from './heraldry/duchy-duchy-of-kartli.webp';
import a_heraldry_duchy_duchy_of_gesuella_webp from './heraldry/duchy-duchy-of-gesuella.webp';
import a_heraldry_duchy_duchy_of_krosbor_webp from './heraldry/duchy-duchy-of-krosbor.webp';
import a_heraldry_duchy_duchy_of_sougdaia_webp from './heraldry/duchy-duchy-of-sougdaia.webp';
import a_heraldry_duchy_duchy_of_lower_egypt_webp from './heraldry/duchy-duchy-of-lower-egypt.webp';
import a_heraldry_duchy_duchy_of_damascus_webp from './heraldry/duchy-duchy-of-damascus.webp';
import a_heraldry_duchy_duchy_of_aleppo_webp from './heraldry/duchy-duchy-of-aleppo.webp';
import a_heraldry_duchy_duchy_of_judea_webp from './heraldry/duchy-duchy-of-judea.webp';
import a_heraldry_duchy_duchy_of_iraq_webp from './heraldry/duchy-duchy-of-iraq.webp';
import a_heraldry_duchy_duchy_of_basra_webp from './heraldry/duchy-duchy-of-basra.webp';
import a_heraldry_duchy_duchy_of_jazira_webp from './heraldry/duchy-duchy-of-jazira.webp';
import a_heraldry_duchy_duchy_of_amida_webp from './heraldry/duchy-duchy-of-amida.webp';
import a_heraldry_duchy_duchy_of_azerbaijan_webp from './heraldry/duchy-duchy-of-azerbaijan.webp';
import a_heraldry_duchy_duchy_of_iceland_webp from './heraldry/duchy-duchy-of-iceland.webp';
import a_heraldry_duchy_duchy_of_ansbach_webp from './heraldry/duchy-duchy-of-ansbach.webp';
import a_heraldry_duchy_duchy_of_falkenau_webp from './heraldry/duchy-duchy-of-falkenau.webp';
import a_heraldry_duchy_duchy_of_haldor_webp from './heraldry/duchy-duchy-of-haldor.webp';
import a_heraldry_duchy_duchy_of_dornburg_webp from './heraldry/duchy-duchy-of-dornburg.webp';
import a_heraldry_duchy_duchy_of_hjelm_webp from './heraldry/duchy-duchy-of-hjelm.webp';
import a_heraldry_duchy_duchy_of_tanum_webp from './heraldry/duchy-duchy-of-tanum.webp';
import a_heraldry_duchy_duchy_of_sayn_webp from './heraldry/duchy-duchy-of-sayn.webp';
import a_heraldry_duchy_duchy_of_kalden_webp from './heraldry/duchy-duchy-of-kalden.webp';
import a_heraldry_duchy_duchy_of_borgund_webp from './heraldry/duchy-duchy-of-borgund.webp';
import a_heraldry_duchy_duchy_of_arnsberg_webp from './heraldry/duchy-duchy-of-arnsberg.webp';
import a_heraldry_duchy_duchy_of_marbach_webp from './heraldry/duchy-duchy-of-marbach.webp';
import a_heraldry_duchy_duchy_of_freiburg_webp from './heraldry/duchy-duchy-of-freiburg.webp';
import a_heraldry_duchy_duchy_of_heiligen_webp from './heraldry/duchy-duchy-of-heiligen.webp';
import a_heraldry_duchy_duchy_of_nesje_webp from './heraldry/duchy-duchy-of-nesje.webp';
import a_heraldry_duchy_duchy_of_herse_webp from './heraldry/duchy-duchy-of-herse.webp';
import a_heraldry_duchy_duchy_of_rheinau_webp from './heraldry/duchy-duchy-of-rheinau.webp';
import a_heraldry_duchy_duchy_of_kirchberg_webp from './heraldry/duchy-duchy-of-kirchberg.webp';
import a_heraldry_duchy_duchy_of_stange_webp from './heraldry/duchy-duchy-of-stange.webp';
import a_heraldry_duchy_duchy_of_waldeck_webp from './heraldry/duchy-duchy-of-waldeck.webp';
import a_heraldry_duchy_duchy_of_bernau_webp from './heraldry/duchy-duchy-of-bernau.webp';
import a_heraldry_duchy_duchy_of_elshausen_webp from './heraldry/duchy-duchy-of-elshausen.webp';
import a_heraldry_duchy_duchy_of_vardal_webp from './heraldry/duchy-duchy-of-vardal.webp';
import a_heraldry_duchy_duchy_of_schaum_webp from './heraldry/duchy-duchy-of-schaum.webp';
import a_heraldry_duchy_duchy_of_falun_webp from './heraldry/duchy-duchy-of-falun.webp';
import a_heraldry_duchy_duchy_of_kolding_webp from './heraldry/duchy-duchy-of-kolding.webp';
import a_heraldry_duchy_duchy_of_landfeld_webp from './heraldry/duchy-duchy-of-landfeld.webp';
import a_heraldry_duchy_duchy_of_fjaere_webp from './heraldry/duchy-duchy-of-fjaere.webp';
import a_heraldry_duchy_duchy_of_schaumwalde_webp from './heraldry/duchy-duchy-of-schaumwalde.webp';
import a_heraldry_duchy_duchy_of_bernheim_webp from './heraldry/duchy-duchy-of-bernheim.webp';
import a_heraldry_duchy_duchy_of_iseneck_webp from './heraldry/duchy-duchy-of-iseneck.webp';
import a_heraldry_duchy_duchy_of_weinthal_webp from './heraldry/duchy-duchy-of-weinthal.webp';
import a_heraldry_duchy_duchy_of_arnsbach_webp from './heraldry/duchy-duchy-of-arnsbach.webp';
import a_heraldry_duchy_duchy_of_teckwalde_webp from './heraldry/duchy-duchy-of-teckwalde.webp';
import a_heraldry_duchy_duchy_of_steineck_webp from './heraldry/duchy-duchy-of-steineck.webp';
import a_heraldry_duchy_duchy_of_torpoy_webp from './heraldry/duchy-duchy-of-torpoy.webp';
import a_heraldry_duchy_duchy_of_varness_webp from './heraldry/duchy-duchy-of-varness.webp';
import a_heraldry_duchy_duchy_of_fjaeoy_webp from './heraldry/duchy-duchy-of-fjaeoy.webp';
import a_heraldry_duchy_duchy_of_zellstein_webp from './heraldry/duchy-duchy-of-zellstein.webp';
import a_heraldry_duchy_duchy_of_heilstein_webp from './heraldry/duchy-duchy-of-heilstein.webp';
import a_heraldry_duchy_duchy_of_grafeck_webp from './heraldry/duchy-duchy-of-grafeck.webp';
import a_heraldry_duchy_duchy_of_zollrode_webp from './heraldry/duchy-duchy-of-zollrode.webp';
import a_heraldry_duchy_duchy_of_rotheim_webp from './heraldry/duchy-duchy-of-rotheim.webp';
import a_heraldry_duchy_duchy_of_skiholm_webp from './heraldry/duchy-duchy-of-skiholm.webp';
import a_heraldry_duchy_duchy_of_blankfeld_webp from './heraldry/duchy-duchy-of-blankfeld.webp';
import a_heraldry_duchy_duchy_of_ebersthal_webp from './heraldry/duchy-duchy-of-ebersthal.webp';
import a_heraldry_duchy_duchy_of_geldberg_webp from './heraldry/duchy-duchy-of-geldberg.webp';
import a_heraldry_duchy_duchy_of_wolfberg_webp from './heraldry/duchy-duchy-of-wolfberg.webp';
import a_heraldry_duchy_duchy_of_lichthal_webp from './heraldry/duchy-duchy-of-lichthal.webp';
import a_heraldry_duchy_duchy_of_renness_webp from './heraldry/duchy-duchy-of-renness.webp';
import a_heraldry_duchy_duchy_of_falkfurt_webp from './heraldry/duchy-duchy-of-falkfurt.webp';
import a_heraldry_duchy_duchy_of_lichwalde_webp from './heraldry/duchy-duchy-of-lichwalde.webp';
import a_heraldry_duchy_duchy_of_neuwalde_webp from './heraldry/duchy-duchy-of-neuwalde.webp';
import a_heraldry_duchy_duchy_of_bregburg_webp from './heraldry/duchy-duchy-of-bregburg.webp';
import a_heraldry_duchy_duchy_of_passwalde_webp from './heraldry/duchy-duchy-of-passwalde.webp';
import a_heraldry_duchy_duchy_of_nordness_webp from './heraldry/duchy-duchy-of-nordness.webp';
import a_heraldry_duchy_duchy_of_gutenthal_webp from './heraldry/duchy-duchy-of-gutenthal.webp';
import a_heraldry_duchy_duchy_of_oldau_webp from './heraldry/duchy-duchy-of-oldau.webp';
import a_heraldry_duchy_duchy_of_hersfurt_webp from './heraldry/duchy-duchy-of-hersfurt.webp';
import a_heraldry_duchy_duchy_of_passbach_webp from './heraldry/duchy-duchy-of-passbach.webp';
import a_heraldry_duchy_duchy_of_glenarm_webp from './heraldry/duchy-duchy-of-glenarm.webp';
import a_heraldry_duchy_duchy_of_oberdorf_webp from './heraldry/duchy-duchy-of-oberdorf.webp';
import a_heraldry_duchy_duchy_of_lichdorf_webp from './heraldry/duchy-duchy-of-lichdorf.webp';
import a_heraldry_duchy_duchy_of_beilthal_webp from './heraldry/duchy-duchy-of-beilthal.webp';
import a_heraldry_duchy_duchy_of_ardgour_webp from './heraldry/duchy-duchy-of-ardgour.webp';
import a_heraldry_duchy_duchy_of_ansberg_webp from './heraldry/duchy-duchy-of-ansberg.webp';
import a_heraldry_duchy_duchy_of_wolfbach_webp from './heraldry/duchy-duchy-of-wolfbach.webp';
import a_heraldry_duchy_duchy_of_elsheim_webp from './heraldry/duchy-duchy-of-elsheim.webp';
import a_heraldry_duchy_duchy_of_geldburg_webp from './heraldry/duchy-duchy-of-geldburg.webp';
import a_heraldry_duchy_duchy_of_freithal_webp from './heraldry/duchy-duchy-of-freithal.webp';
import a_heraldry_duchy_duchy_of_arnsthal_webp from './heraldry/duchy-duchy-of-arnsthal.webp';
import a_heraldry_duchy_duchy_of_dunollie_webp from './heraldry/duchy-duchy-of-dunollie.webp';
import a_heraldry_duchy_duchy_of_srem_webp from './heraldry/duchy-duchy-of-srem.webp';
import a_heraldry_duchy_duchy_of_lobwalde_webp from './heraldry/duchy-duchy-of-lobwalde.webp';
import a_heraldry_duchy_duchy_of_hallberg_webp from './heraldry/duchy-duchy-of-hallberg.webp';
import a_heraldry_duchy_duchy_of_nesfjord_webp from './heraldry/duchy-duchy-of-nesfjord.webp';
import a_heraldry_duchy_duchy_of_cranheim_webp from './heraldry/duchy-duchy-of-cranheim.webp';
import a_heraldry_duchy_duchy_of_arnsfurt_webp from './heraldry/duchy-duchy-of-arnsfurt.webp';
import a_heraldry_duchy_duchy_of_freifurt_webp from './heraldry/duchy-duchy-of-freifurt.webp';
import a_heraldry_duchy_duchy_of_schaumfurt_webp from './heraldry/duchy-duchy-of-schaumfurt.webp';
import a_heraldry_duchy_duchy_of_bielsk_webp from './heraldry/duchy-duchy-of-bielsk.webp';
import a_heraldry_duchy_duchy_of_cranhausen_webp from './heraldry/duchy-duchy-of-cranhausen.webp';
import a_heraldry_duchy_duchy_of_cranwalde_webp from './heraldry/duchy-duchy-of-cranwalde.webp';
import a_heraldry_duchy_duchy_of_dieswalde_webp from './heraldry/duchy-duchy-of-dieswalde.webp';
import a_heraldry_duchy_duchy_of_gutenfurt_webp from './heraldry/duchy-duchy-of-gutenfurt.webp';
import a_heraldry_duchy_duchy_of_eicheim_webp from './heraldry/duchy-duchy-of-eicheim.webp';
import a_heraldry_duchy_duchy_of_hallheim_webp from './heraldry/duchy-duchy-of-hallheim.webp';
import a_heraldry_duchy_duchy_of_heilbach_webp from './heraldry/duchy-duchy-of-heilbach.webp';
import a_heraldry_duchy_duchy_of_kesteven_webp from './heraldry/duchy-duchy-of-kesteven.webp';
import a_heraldry_duchy_duchy_of_hallfeld_webp from './heraldry/duchy-duchy-of-hallfeld.webp';
import a_heraldry_duchy_duchy_of_aubigny_webp from './heraldry/duchy-duchy-of-aubigny.webp';
import a_heraldry_duchy_duchy_of_hohfurt_webp from './heraldry/duchy-duchy-of-hohfurt.webp';
import a_heraldry_duchy_duchy_of_wolfrode_webp from './heraldry/duchy-duchy-of-wolfrode.webp';
import a_heraldry_duchy_duchy_of_ansthal_webp from './heraldry/duchy-duchy-of-ansthal.webp';
import a_heraldry_duchy_duchy_of_schaumdorf_webp from './heraldry/duchy-duchy-of-schaumdorf.webp';
import a_heraldry_duchy_duchy_of_lobhausen_webp from './heraldry/duchy-duchy-of-lobhausen.webp';
import a_heraldry_duchy_duchy_of_andros_webp from './heraldry/duchy-duchy-of-andros.webp';
import a_heraldry_duchy_duchy_of_sarno_webp from './heraldry/duchy-duchy-of-sarno.webp';
import a_heraldry_duchy_duchy_of_montaigu_webp from './heraldry/duchy-duchy-of-montaigu.webp';
import a_heraldry_duchy_duchy_of_geldeck_webp from './heraldry/duchy-duchy-of-geldeck.webp';
import a_heraldry_duchy_duchy_of_somogy_webp from './heraldry/duchy-duchy-of-somogy.webp';
import a_heraldry_duchy_duchy_of_naupaktos_webp from './heraldry/duchy-duchy-of-naupaktos.webp';
import a_heraldry_duchy_duchy_of_roththal_webp from './heraldry/duchy-duchy-of-roththal.webp';
import a_heraldry_duchy_duchy_of_isernia_webp from './heraldry/duchy-duchy-of-isernia.webp';
import a_heraldry_duchy_duchy_of_bernrode_webp from './heraldry/duchy-duchy-of-bernrode.webp';
import a_heraldry_duchy_duchy_of_conza_webp from './heraldry/duchy-duchy-of-conza.webp';
import a_heraldry_duchy_duchy_of_gomhely_webp from './heraldry/duchy-duchy-of-gomhely.webp';
import a_heraldry_duchy_duchy_of_miedgrad_webp from './heraldry/duchy-duchy-of-miedgrad.webp';
import a_heraldry_duchy_duchy_of_buonalbergo_webp from './heraldry/duchy-duchy-of-buonalbergo.webp';
import a_heraldry_duchy_duchy_of_zbarsk_webp from './heraldry/duchy-duchy-of-zbarsk.webp';
import a_heraldry_duchy_duchy_of_turyn_webp from './heraldry/duchy-duchy-of-turyn.webp';
import a_heraldry_duchy_duchy_of_marsico_webp from './heraldry/duchy-duchy-of-marsico.webp';
import a_heraldry_duchy_duchy_of_lesina_webp from './heraldry/duchy-duchy-of-lesina.webp';
import a_heraldry_duchy_duchy_of_montoro_webp from './heraldry/duchy-duchy-of-montoro.webp';
import a_heraldry_duchy_duchy_of_avelago_webp from './heraldry/duchy-duchy-of-avelago.webp';
import a_heraldry_duchy_duchy_of_eichfurt_webp from './heraldry/duchy-duchy-of-eichfurt.webp';
import a_heraldry_duchy_duchy_of_ilbira_webp from './heraldry/duchy-duchy-of-ilbira.webp';
import a_heraldry_duchy_duchy_of_rayyaya_webp from './heraldry/duchy-duchy-of-rayyaya.webp';
import a_heraldry_duchy_duchy_of_steinrode_webp from './heraldry/duchy-duchy-of-steinrode.webp';
import a_heraldry_duchy_duchy_of_muntiyya_webp from './heraldry/duchy-duchy-of-muntiyya.webp';
import a_heraldry_duchy_duchy_of_kastamon_webp from './heraldry/duchy-duchy-of-kastamon.webp';
import a_heraldry_duchy_duchy_of_zollburg_webp from './heraldry/duchy-duchy-of-zollburg.webp';
import a_heraldry_duchy_duchy_of_rundisa_webp from './heraldry/duchy-duchy-of-rundisa.webp';
import a_heraldry_duchy_duchy_of_madinira_webp from './heraldry/duchy-duchy-of-madinira.webp';
import a_heraldry_duchy_duchy_of_nablus_webp from './heraldry/duchy-duchy-of-nablus.webp';
import a_heraldry_duchy_duchy_of_jayida_webp from './heraldry/duchy-duchy-of-jayida.webp';
import a_heraldry_duchy_duchy_of_zawat_webp from './heraldry/duchy-duchy-of-zawat.webp';
import a_heraldry_duchy_duchy_of_kiutahia_webp from './heraldry/duchy-duchy-of-kiutahia.webp';
import a_heraldry_duchy_duchy_of_ubbira_webp from './heraldry/duchy-duchy-of-ubbira.webp';
import a_heraldry_duchy_duchy_of_qabrisa_webp from './heraldry/duchy-duchy-of-qabrisa.webp';
import a_heraldry_duchy_duchy_of_qasruna_webp from './heraldry/duchy-duchy-of-qasruna.webp';
import a_heraldry_duchy_duchy_of_hisnaya_webp from './heraldry/duchy-duchy-of-hisnaya.webp';
import a_heraldry_duchy_duchy_of_marqiyya_webp from './heraldry/duchy-duchy-of-marqiyya.webp';
import a_heraldry_duchy_duchy_of_shaubak_webp from './heraldry/duchy-duchy-of-shaubak.webp';
import a_heraldry_duchy_duchy_of_wadiyya_webp from './heraldry/duchy-duchy-of-wadiyya.webp';
import a_heraldry_duchy_duchy_of_miloba_webp from './heraldry/duchy-duchy-of-miloba.webp';
import a_heraldry_duchy_duchy_of_hierhisar_webp from './heraldry/duchy-duchy-of-hierhisar.webp';
import a_heraldry_duchy_duchy_of_muntaya_webp from './heraldry/duchy-duchy-of-muntaya.webp';
import a_heraldry_duchy_duchy_of_qabrira_webp from './heraldry/duchy-duchy-of-qabrira.webp';
import a_heraldry_duchy_duchy_of_attaliye_webp from './heraldry/duchy-duchy-of-attaliye.webp';
import a_heraldry_duchy_duchy_of_garnaya_webp from './heraldry/duchy-duchy-of-garnaya.webp';
import a_heraldry_duchy_duchy_of_nibira_webp from './heraldry/duchy-duchy-of-nibira.webp';
import a_heraldry_duchy_duchy_of_zawula_webp from './heraldry/duchy-duchy-of-zawula.webp';
import a_heraldry_duchy_duchy_of_tralldere_webp from './heraldry/duchy-duchy-of-tralldere.webp';
import a_heraldry_duchy_duchy_of_rayyat_webp from './heraldry/duchy-duchy-of-rayyat.webp';
import a_heraldry_duchy_duchy_of_qabrat_webp from './heraldry/duchy-duchy-of-qabrat.webp';
import a_heraldry_duchy_duchy_of_ikoneli_webp from './heraldry/duchy-duchy-of-ikoneli.webp';
import a_heraldry_duchy_duchy_of_firrana_webp from './heraldry/duchy-duchy-of-firrana.webp';
import a_heraldry_duchy_duchy_of_kastamdere_webp from './heraldry/duchy-duchy-of-kastamdere.webp';
import a_heraldry_duchy_duchy_of_mileli_webp from './heraldry/duchy-duchy-of-mileli.webp';
import a_heraldry_duchy_duchy_of_choniye_webp from './heraldry/duchy-duchy-of-choniye.webp';
import a_heraldry_empire_e_britannia_webp from './heraldry/empire-e-britannia.webp';
import a_heraldry_empire_e_francia_webp from './heraldry/empire-e-francia.webp';
import a_heraldry_empire_e_hispania_webp from './heraldry/empire-e-hispania.webp';
import a_heraldry_empire_e_germania_webp from './heraldry/empire-e-germania.webp';
import a_heraldry_empire_e_italia_webp from './heraldry/empire-e-italia.webp';
import a_heraldry_empire_e_scandinavia_webp from './heraldry/empire-e-scandinavia.webp';
import a_heraldry_empire_e_carpathia_webp from './heraldry/empire-e-carpathia.webp';
import a_heraldry_empire_e_rus_webp from './heraldry/empire-e-rus.webp';
import a_heraldry_empire_e_byzantium_webp from './heraldry/empire-e-byzantium.webp';
import a_heraldry_empire_e_maghreb_webp from './heraldry/empire-e-maghreb.webp';
import a_heraldry_empire_e_arabia_webp from './heraldry/empire-e-arabia.webp';
import a_heraldry_empire_e_anatolia_webp from './heraldry/empire-e-anatolia.webp';

export interface ArtCard {
  url: string;
  thumb: string;
  width: number;
  height: number;
}

/** Portrait art by unit type. Every unit in the roster has one. */
export const UNIT_ART: Record<string, ArtCard> = {
  spearman: { url: a_units_spearman_webp, thumb: a_units_spearman_thumb_webp, width: 240, height: 300 },
  swordsman: { url: a_units_swordsman_webp, thumb: a_units_swordsman_thumb_webp, width: 240, height: 300 },
  axeman: { url: a_units_axeman_webp, thumb: a_units_axeman_thumb_webp, width: 240, height: 300 },
  militia_archer: { url: a_units_militia_archer_webp, thumb: a_units_militia_archer_thumb_webp, width: 240, height: 300 },
  archer: { url: a_units_archer_webp, thumb: a_units_archer_thumb_webp, width: 240, height: 300 },
  crossbowman: { url: a_units_crossbowman_webp, thumb: a_units_crossbowman_thumb_webp, width: 240, height: 299 },
  scout: { url: a_units_scout_webp, thumb: a_units_scout_thumb_webp, width: 240, height: 300 },
  light_cavalry: { url: a_units_light_cavalry_webp, thumb: a_units_light_cavalry_thumb_webp, width: 240, height: 300 },
  heavy_cavalry: { url: a_units_heavy_cavalry_webp, thumb: a_units_heavy_cavalry_thumb_webp, width: 240, height: 300 },
  knight: { url: a_units_knight_webp, thumb: a_units_knight_thumb_webp, width: 240, height: 300 },
  ram: { url: a_units_ram_webp, thumb: a_units_ram_thumb_webp, width: 240, height: 300 },
  catapult: { url: a_units_catapult_webp, thumb: a_units_catapult_thumb_webp, width: 240, height: 300 },
  bailiff: { url: a_units_bailiff_webp, thumb: a_units_bailiff_thumb_webp, width: 240, height: 300 },
  cannon: { url: a_units_cannon_webp, thumb: a_units_cannon_thumb_webp, width: 240, height: 300 },
  cog: { url: a_units_cog_webp, thumb: a_units_cog_thumb_webp, width: 240, height: 300 },
  longship: { url: a_units_longship_webp, thumb: a_units_longship_thumb_webp, width: 240, height: 300 },
  war_galley: { url: a_units_war_galley_webp, thumb: a_units_war_galley_thumb_webp, width: 240, height: 300 },
};

/** Resource-bar renders, keyed by resource plus `population`. */
export const RESOURCE_ART: Record<string, string> = {
  wood: a_resources_wood_webp,
  clay: a_resources_clay_webp,
  iron: a_resources_iron_webp,
  grain: a_resources_grain_webp,
  population: a_resources_population_webp,
};

export const VILLAGE_BACKDROPS = {
  open: a_backdrops_open_jpg,
  palisade: a_backdrops_palisade_jpg,
  stonewall: a_backdrops_stonewall_jpg,
  shoreOpen: a_backdrops_shoreOpen_jpg,
  shorePalisade: a_backdrops_shorePalisade_jpg,
} as const;

/**
 * The holding gains its fortifications as the Wall goes up, matching the
 * three tiers of wall artwork on the sprite sheet.
 *
 * A coastal holding is drawn on the shore plates instead. Only two of
 * those were painted, so a walled port keeps the palisade shore rather
 * than being moved inland by its own stonework.
 */
export function backdropForWall(wallLevel: number, coastal = false): string {
  if (coastal) {
    return wallLevel >= 1 ? VILLAGE_BACKDROPS.shorePalisade : VILLAGE_BACKDROPS.shoreOpen;
  }
  if (wallLevel >= 10) return VILLAGE_BACKDROPS.stonewall;
  if (wallLevel >= 1) return VILLAGE_BACKDROPS.palisade;
  return VILLAGE_BACKDROPS.open;
}

export const PAGE_ART = {
  landing: a_pages_landing_webp,
  logo: a_pages_logo_webp,
  wordmark: a_pages_wordmark_webp,
  tutor: a_pages_tutor_webp,
  reportSiege: a_pages_reportSiege_webp,
  reportCamp: a_pages_reportCamp_webp,
  reportScout: a_pages_reportScout_webp,
  sidePanel: a_pages_sidePanel_webp,
} as const;

/** In-game UI icons: points, loyalty, alliance, scroll. */
export const GAME_ICONS = {
  points: a_ui_points_webp,
  loyalty: a_ui_loyalty_webp,
  alliance: a_ui_alliance_webp,
  military: a_ui_military_webp,
  market: a_ui_market_webp,
  reports: a_ui_reports_webp,
  buildings: a_ui_buildings_webp,
  world: a_ui_world_webp,
  scroll: a_ui_scroll_webp,
  forum: a_ui_forum_webp,
  gold: a_ui_gold_webp,
  orderAttack: a_ui_orderAttack_webp,
  orderRaid: a_ui_orderRaid_webp,
  orderSupport: a_ui_orderSupport_webp,
  orderScout: a_ui_orderScout_webp,
  orderRecall: a_ui_orderRecall_webp,
  orderEnter: a_ui_orderEnter_webp,
  orderClear: a_ui_orderClear_webp,
  reportBattle: a_ui_reportBattle_webp,
  reportScouting: a_ui_reportScouting_webp,
  reportRaid: a_ui_reportRaid_webp,
  domain: a_ui_domain_webp,
  prestige: a_ui_prestige_webp,
  portrait: a_ui_portrait_webp,
  letters: a_ui_letters_webp,
  settings: a_ui_settings_webp,
} as const;

/**
 * Frames for the four rungs of a title, largest first on the map.
 *
 * The duchy, kingdom and empire frames are hollow, so a device can be
 * drawn inside them. The county frame is filled: there are too many
 * counties for any of them to have arms.
 */
export const TITLE_CRESTS = {
  county: { src: a_crests_county_webp, w: 128, h: 134 },
  duchy: { src: a_crests_duchy_webp, w: 256, h: 269 },
  kingdom: { src: a_crests_kingdom_webp, w: 256, h: 293 },
  empire: { src: a_crests_empire_webp, w: 256, h: 257 },
} as const;

/**
 * Card art for the research screen, keyed by node id.
 *
 * Each card carries its own frame, its Manor gate and its name, so the
 * screen draws the art and adds only what changes: cost, taken, blocked.
 */
export const RESEARCH_CARDS: Record<string, { src: string; w: number; h: number }> = {
  three_field: { src: a_research_three_field_webp, w: 441, h: 236 },
  drill_yards: { src: a_research_drill_yards_webp, w: 445, h: 238 },
  chancery: { src: a_research_chancery_webp, w: 436, h: 236 },
  master_masons: { src: a_research_master_masons_webp, w: 441, h: 225 },
  muster_rolls: { src: a_research_muster_rolls_webp, w: 444, h: 228 },
  heralds: { src: a_research_heralds_webp, w: 436, h: 234 },
  deep_mines: { src: a_research_deep_mines_webp, w: 444, h: 254 },
  armouries: { src: a_research_armouries_webp, w: 442, h: 250 },
  vassal_courts: { src: a_research_vassal_courts_webp, w: 436, h: 250 },
  crown_works: { src: a_research_crown_works_webp, w: 445, h: 240 },
  veteran_cadres: { src: a_research_veteran_cadres_webp, w: 442, h: 240 },
  imperial_chancery: { src: a_research_imperial_chancery_webp, w: 434, h: 238 },
};

/**
 * The plates a marching column is drawn from, keyed by icon name.
 *
 * Which plate a column shows is decided by `fieldColumn` in the shared
 * package; this is only the art.
 */
export const FIELD_ICONS: Record<string, { src: string; w: number; h: number }> = {
  infantry: { src: a_field_infantry_webp, w: 128, h: 131 },
  cavalry: { src: a_field_cavalry_webp, w: 128, h: 131 },
  horseArcher: { src: a_field_horseArcher_webp, w: 128, h: 129 },
  captain: { src: a_field_captain_webp, w: 128, h: 130 },
  heavy: { src: a_field_heavy_webp, w: 128, h: 130 },
  archer: { src: a_field_archer_webp, w: 128, h: 131 },
  cannon: { src: a_field_cannon_webp, w: 128, h: 200 },
  catapult: { src: a_field_catapult_webp, w: 128, h: 241 },
  ram: { src: a_field_ram_webp, w: 128, h: 266 },
};

/**
 * The emblems an army preset can wear, keyed by icon name.
 *
 * The keys are `PRESET_ICON_KEYS` in the shared package, which is what the
 * server validates against; this is only the art.
 */
export const PRESET_ICONS: Record<string, { src: string; w: number; h: number }> = {
  swords: { src: a_preset_swords_webp, w: 96, h: 95 },
  shield: { src: a_preset_shield_webp, w: 96, h: 95 },
  torch: { src: a_preset_torch_webp, w: 96, h: 95 },
  horse: { src: a_preset_horse_webp, w: 96, h: 95 },
  bow: { src: a_preset_bow_webp, w: 96, h: 96 },
  ram: { src: a_preset_ram_webp, w: 96, h: 96 },
  crown: { src: a_preset_crown_webp, w: 96, h: 96 },
  skull: { src: a_preset_skull_webp, w: 96, h: 96 },
  wheat: { src: a_preset_wheat_webp, w: 96, h: 95 },
  ship: { src: a_preset_ship_webp, w: 96, h: 95 },
  tower: { src: a_preset_tower_webp, w: 96, h: 95 },
  spear: { src: a_preset_spear_webp, w: 96, h: 95 },
  horn: { src: a_preset_horn_webp, w: 96, h: 95 },
  wolf: { src: a_preset_wolf_webp, w: 96, h: 95 },
  hourglass: { src: a_preset_hourglass_webp, w: 96, h: 95 },
  pennant: { src: a_preset_pennant_webp, w: 96, h: 95 },
};

/**
 * The painting on each task, keyed by the quest id it belongs to.
 *
 * Ids are the ones in `constants/quests.ts`. A task with no card here
 * simply shows none, so a new quest can land before its artwork does.
 */
export const TASK_CARDS: Record<string, { src: string; w: number; h: number }> = {
  'first-timber': { src: a_task_first_timber_webp, w: 192, h: 207 },
  'clay-and-iron': { src: a_task_clay_and_iron_webp, w: 192, h: 206 },
  'iron-in-the-hills': { src: a_task_iron_in_the_hills_webp, w: 192, h: 206 },
  'feed-them': { src: a_task_feed_them_webp, w: 192, h: 206 },
  'somewhere-to-put-it': { src: a_task_somewhere_to_put_it_webp, w: 192, h: 205 },
  'seat-of-the-lord': { src: a_task_seat_of_the_lord_webp, w: 192, h: 204 },
  'raise-a-guard': { src: a_task_raise_a_guard_webp, w: 192, h: 204 },
  'first-blood': { src: a_task_first_blood_webp, w: 192, h: 204 },
  'a-standing-army': { src: a_task_a_standing_army_webp, w: 192, h: 204 },
  'stone-on-stone': { src: a_task_stone_on_stone_webp, w: 192, h: 201 },
  'three-camps': { src: a_task_three_camps_webp, w: 192, h: 190 },
  'find-friends': { src: a_task_find_friends_webp, w: 192, h: 187 },
  'a-place-of-note': { src: a_task_a_place_of_note_webp, w: 192, h: 190 },
};

/**
 * Quick-notification plates, keyed by the kind of news a toast carries.
 *
 * Which plate a toast shows is decided in the notifications store; this
 * is only the art.
 */
export const NOTIFY_PLATES: Record<string, { src: string; w: number; h: number }> = {
  scroll: { src: a_notify_scroll_webp, w: 640, h: 108 },
  battle: { src: a_notify_battle_webp, w: 640, h: 110 },
  shield: { src: a_notify_shield_webp, w: 640, h: 105 },
  castle: { src: a_notify_castle_webp, w: 640, h: 107 },
  letter: { src: a_notify_letter_webp, w: 640, h: 115 },
  horn: { src: a_notify_horn_webp, w: 640, h: 102 },
  grain: { src: a_notify_grain_webp, w: 640, h: 110 },
  alert: { src: a_notify_alert_webp, w: 640, h: 104 },
};

/** Seamless ground textures keyed by terrain type. */
export const MAP_TEXTURES: Record<string, string> = {
  plains: a_map_plains_webp,
  desert: a_map_desert_webp,
  forest: a_map_forest_webp,
  hills: a_map_hills_webp,
  mountain: a_map_mountain_webp,
  ocean: a_map_ocean_webp,
  shallows: a_map_shallows_webp,
};

/**
 * Tiled art drawn *over* the ground for a terrain, keyed by terrain.
 *
 * Forest is grass with trees scattered on top rather than a green
 * texture of its own, so a treeline reads as a treeline.
 */
export const MAP_OVERLAYS: Record<string, { src: string; tiles: number }> = {
  forest: { src: a_map_forest_overlay_webp, tiles: 3.5 },
};

/**
 * Individual clouds, cut from one overcast plate and faded at the rim.
 *
 * Drawn as drifting sprites rather than tiled as a texture: the source is a
 * solid sky, and tiling a solid sky produces fog rather than weather.
 */
/** Mountain massifs, scattered over mountain ground rather than tiled. */
export const MAP_MOUNTAINS: string[] = [
  a_map_mountain_0_webp,
  a_map_mountain_1_webp,
];

export const MAP_CLOUDS: string[] = [
  a_map_cloud_0_webp,
  a_map_cloud_1_webp,
  a_map_cloud_2_webp,
  a_map_cloud_3_webp,
  a_map_cloud_4_webp,
  a_map_cloud_5_webp,
];

export const MAP_TEXTURE_SIZE = 384;

/** Non-village things that stand on the world map. */
export const MAP_MARKERS = {
  banditCamp: a_map_markers_banditCamp_webp,
} as const;

/**
 * Real arms for the titles that genuinely bore them, keyed `tier:key`.
 *
 * Absent for every other title, which falls back to the painted blazon.
 * That is deliberate rather than unfinished: most duchies here are invented
 * names, ten of the twelve empires never existed, and several real realms
 * bore no European heraldry at all in 1212.
 *
 * `licence` and `artist` are not decoration. Anything that is not public
 * domain must appear in the credits, and this is where that list comes from.
 */
export interface RealArms {
  src: string;
  licence: string;
  artist: string;
  source: string;
  sourceUrl: string;
  /** Why this file, and how far the claim goes. Shown in the credits. */
  why: string;
}
export const REAL_ARMS: Record<string, RealArms> = {
  "kingdom:k_portugal": {
    src: a_heraldry_kingdom_k_portugal_webp,
    licence: "CC BY-SA 4.0",
    artist: "FDRMRZUSA (talk · contribs). See sourced file for original author.",
    source: "Flag of the Kingdom of Portugal (1185–1248).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Flag_of_the_Kingdom_of_Portugal_(1185%E2%80%931248).svg",
    why: "The quinas as borne 1185-1248, so exactly the banner Afonso II flew in 1212. Wikidata offered the modern arms in a laurel wreath.",
  },
  "kingdom:k_leon": {
    src: a_heraldry_kingdom_k_leon_webp,
    licence: "CC BY-SA 3.0",
    artist: "Heralder",
    source: "Arms of León.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_Le%C3%B3n.svg",
    why: "The lion under Alfonso IX (1188-1230), on a heater like the rest of the set.",
  },
  "kingdom:k_castile": {
    src: a_heraldry_kingdom_k_castile_webp,
    licence: "CC BY-SA 4.0",
    artist: "Heralder",
    source: "Arms of Castile.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_Castile.svg",
    why: "The castle, borne by Alfonso VIII who won Las Navas de Tolosa in 1212.",
  },
  "kingdom:k_navarre": {
    src: a_heraldry_kingdom_k_navarre_webp,
    licence: "CC BY-SA 3.0",
    artist: "Tom Lemmens",
    source: "Coat of Arms of the Kingdom of Navarre.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_the_Kingdom_of_Navarre.svg",
    why: "The chains, traditionally dated to Las Navas de Tolosa itself.",
  },
  "kingdom:k_aragon": {
    src: a_heraldry_kingdom_k_aragon_webp,
    licence: "CC BY-SA 3.0",
    artist: "Heralder",
    source: "Royal arms of Aragon (Crowned).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Royal_arms_of_Aragon_(Crowned).svg",
    why: "The pales of Aragon under Peter II.",
  },
  "kingdom:k_andalusia": {
    src: a_heraldry_kingdom_k_andalusia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Humbert de Savoie (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Humbert_de_Savoie_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_valencia": {
    src: a_heraldry_kingdom_k_valencia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Gilles d'Arnemuiden (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Gilles_d%27Arnemuiden_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_morocco": {
    src: a_heraldry_kingdom_k_morocco_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Franck de Borsele (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Franck_de_Borsele_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_tlemcen": {
    src: a_heraldry_kingdom_k_tlemcen_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Houweningen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Houweningen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_ifriqiya": {
    src: a_heraldry_kingdom_k_ifriqiya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Halmale (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Halmale_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_france": {
    src: a_heraldry_kingdom_k_france_webp,
    licence: "Public domain",
    artist: "Kontributor 2K",
    source: "Blason pays fr France ancien.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_pays_fr_France_ancien.svg",
    why: "France Ancien, semy-de-lis, as Philip Augustus bore it. Public domain.",
  },
  "kingdom:k_occitania": {
    src: a_heraldry_kingdom_k_occitania_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kontributor 2K",
    source: "Blason Languedoc.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Languedoc.svg",
    why: "The cross of Toulouse, borne by Raymond VI during the Albigensian war.",
  },
  "kingdom:k_england": {
    src: a_heraldry_kingdom_k_england_webp,
    licence: "CC BY-SA 4.0",
    artist: "Sodacan",
    source: "Royal Arms of England (1198-1340).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Royal_arms_of_England.svg",
    why: "Three lions from 1198. The resolver keeps offering the 1154-1189 arms, which are two.",
  },
  "kingdom:k_ireland": {
    src: a_heraldry_kingdom_k_ireland_webp,
    licence: "CC BY 3.0",
    artist: "NsMn",
    source: "Coat of arms of the Lordship of Ireland.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_the_Lordship_of_Ireland.svg",
    why: "The Lordship of Ireland, which is what it was in 1212 under King John. It had fallen through to a random roll shield while the Duchy of Leinster wore the harp, so the crown looked like a stranger beside its own duchy.",
  },
  "kingdom:k_aquitaine": {
    src: a_heraldry_kingdom_k_aquitaine_webp,
    licence: "CC BY 2.5",
    artist: "You may select the license of your choice.",
    source: "Blason de l'Aquitaine et de la Guyenne.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_de_l%27Aquitaine_et_de_la_Guyenne.svg",
    why: "Wikidata: medieval duchy in southern France. Resolved from \"Kingdom of Aquitaine\".",
  },
  "kingdom:k_scotland": {
    src: a_heraldry_kingdom_k_scotland_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kaliforniyka",
    source: "Royal Arms of the Kingdom of Scotland.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Royal_Arms_of_the_Kingdom_of_Scotland.svg",
    why: "Lion rampant in the double tressure, under William the Lion.",
  },
  "kingdom:k_norway": {
    src: a_heraldry_kingdom_k_norway_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Norvège ancien.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Norv%C3%A8ge_ancien.svg",
    why: "The Norwegian lion before the axe was added around 1280.",
  },
  "kingdom:k_sweden": {
    src: a_heraldry_kingdom_k_sweden_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Tover (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Tover_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_denmark": {
    src: a_heraldry_kingdom_k_denmark_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Danemark ancien.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Danemark_ancien.svg",
    why: "The ancient arms: lions passant and the seme of hearts, attested from about 1194. Wikidata offered the modern national arms under a crown.",
  },
  "kingdom:k_germany": {
    src: a_heraldry_kingdom_k_germany_webp,
    licence: "CC BY-SA 3.0",
    artist: "Ipankonin",
    source: "Holy Roman Empire Arms-single head.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Holy_Roman_Empire_Arms-single_head.svg",
    why: "One head. The double-headed eagle is 15th century.",
  },
  "kingdom:k_burgundy": {
    src: a_heraldry_kingdom_k_burgundy_webp,
    licence: "CC BY-SA 3.0",
    artist: "Thom.lanaud",
    source: "Blason fr Bourgogne.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fr_Bourgogne.svg",
    why: "Wikidata: former administrative region of France. Resolved from \"Kingdom of Burgundy\".",
  },
  "kingdom:k_bohemia": {
    src: a_heraldry_kingdom_k_bohemia_webp,
    licence: "CC BY-SA 3.0",
    artist: "Bluebear2",
    source: "Blason Boheme.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Boheme.svg",
    why: "The double-tailed lion of Ottokar I. A plain shield, not the crowned achievement.",
  },
  "kingdom:k_italy": {
    src: a_heraldry_kingdom_k_italy_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henri de Welchenhausen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henri_de_Welchenhausen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_venice": {
    src: a_heraldry_kingdom_k_venice_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hutin de Vermelles (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hutin_de_Vermelles_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_papal": {
    src: a_heraldry_kingdom_k_papal_webp,
    licence: "CC BY-SA 3.0",
    artist: "Gambo7",
    source: "CoA Pontifical States 02.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:CoA_Pontifical_States_02.svg",
    why: "The crossed keys of Saint Peter.",
  },
  "kingdom:k_sicily": {
    src: a_heraldry_kingdom_k_sicily_webp,
    licence: "CC BY-SA 3.0",
    artist: "Cageteen",
    source: "Armoiries Manfred de Sicile.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Armoiries_Manfred_de_Sicile.svg",
    why: "The Hohenstaufen eagle. Manfred is later than 1212, but Frederick II was king of Sicily that year and it is the same house and the same eagle. Wikidata offered the Aragonese arms, which arrive in 1282.",
  },
  "kingdom:k_hungary": {
    src: a_heraldry_kingdom_k_hungary_webp,
    licence: "Public domain",
    artist: "Madboy74",
    source: "Coa Hungary Country History István V (1239-1272).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coa_Hungary_Country_History_Istv%C3%A1n_V_(1239-1272).svg",
    why: "The Arpad stripes, barry of eight gules and argent, borne by Andrew II who was king in 1212. Arpad arms as a shield, under Stephen V. Both Hungarian flag files on Commons turned out to be swallowtail pennons, and cropping a pennon to a square leaves a white field with a stray red band across it. Public domain.",
  },
  "kingdom:k_poland": {
    src: a_heraldry_kingdom_k_poland_webp,
    licence: "CC BY-SA 4.0",
    artist: "Kingscrow",
    source: "Herb pol.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Herb_pol.svg",
    why: "Wikidata: Jagiellon kingdom of Poland, 1386-1569. Resolved from \"Kingdom of Poland\".",
  },
  "kingdom:k_livonia": {
    src: a_heraldry_kingdom_k_livonia_webp,
    licence: "CC BY 3.0",
    artist: "Thom.lanaud",
    source: "Blason Comtes de Namur (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Comtes_de_Namur_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_novgorod": {
    src: a_heraldry_kingdom_k_novgorod_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Ros (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Ros_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_vladimir": {
    src: a_heraldry_kingdom_k_vladimir_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Liebenstein (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Liebenstein_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_kyiv": {
    src: a_heraldry_kingdom_k_kyiv_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Waleran de Fauquemont (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Waleran_de_Fauquemont_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_galicia": {
    src: a_heraldry_kingdom_k_galicia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Murray (Moray) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Murray_(Moray)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_bulgaria": {
    src: a_heraldry_kingdom_k_bulgaria_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Clan Sinclair (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Clan_Sinclair_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_serbia": {
    src: a_heraldry_kingdom_k_serbia_webp,
    licence: "Public domain",
    artist: "upload: User:Rokerismoravee",
    source: "Coat of arms of Serbia.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Serbia.svg",
    why: "Wikidata: country in Southeast Europe. Resolved from \"Kingdom of Serbia\".",
  },
  "kingdom:k_thrace": {
    src: a_heraldry_kingdom_k_thrace_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empire latin de Constantinople (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empire_latin_de_Constantinople_(selon_Gelre).svg",
    why: "Thrace was Latin Empire ground in 1212.",
  },
  "kingdom:k_thessalonica": {
    src: a_heraldry_kingdom_k_thessalonica_webp,
    licence: "Public domain",
    artist: "Philly boy92 (Trashpanda)",
    source: "Coat of arms of the Kingdom of Thessalonica.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_the_Kingdom_of_Thessalonica.svg",
    why: "The crusader kingdom of 1204, still standing in 1212.",
  },
  "kingdom:k_achaea": {
    src: a_heraldry_kingdom_k_achaea_webp,
    licence: "CC BY-SA 4.0",
    artist: "Thom.lanaud",
    source: "Blason famille de Villehardouin.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_famille_de_Villehardouin.svg",
    why: "Geoffrey I of Villehardouin held Achaea in 1212.",
  },
  "kingdom:k_epirus": {
    src: a_heraldry_kingdom_k_epirus_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hugues Calverley (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hugues_Calverley_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_nicaea": {
    src: a_heraldry_kingdom_k_nicaea_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Moltke (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Moltke_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_trebizond": {
    src: a_heraldry_kingdom_k_trebizond_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empire de Trébizonde (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empire_de_Tr%C3%A9bizonde_(selon_Gelre).svg",
    why: "Trebizond, founded 1204 and standing in 1212.",
  },
  "kingdom:k_rum": {
    src: a_heraldry_kingdom_k_rum_webp,
    licence: "Public domain",
    artist: "Simon.eller",
    source: "Wappen at rum.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Wappen_at_rum.svg",
    why: "Wikidata: municipality in Innsbruck-Land District, Tyrol, Austria. Resolved from \"Sultanate of Rum\".",
  },
  "kingdom:k_cilicia": {
    src: a_heraldry_kingdom_k_cilicia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Spontin (Beaufort) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Spontin_(Beaufort)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_cyprus": {
    src: a_heraldry_kingdom_k_cyprus_webp,
    licence: "CC BY-SA 4.0",
    artist: "James2813",
    source: "Coat of Arms of the House of Lusignan (Kings of Armenia, Cyprus and Jerusalem).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_the_House_of_Lusignan_(Kings_of_Armenia,_Cyprus_and_Jerusalem).svg",
    why: "Lusignan, holding Cyprus from 1192.",
  },
  "kingdom:k_georgia": {
    src: a_heraldry_kingdom_k_georgia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hainaut moderne (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hainaut_moderne_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_antioch": {
    src: a_heraldry_kingdom_k_antioch_webp,
    licence: "CC BY-SA 4.0",
    artist: "Thom.lanaud",
    source: "Blason Bohémond VI d'Antioche.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Boh%C3%A9mond_VI_d%27Antioche.svg",
    why: "Poitiers-Antioch. A generation late, same house and device.",
  },
  "kingdom:k_jerusalem": {
    src: a_heraldry_kingdom_k_jerusalem_webp,
    licence: "CC BY-SA 3.0",
    artist: "HeralderCross by Katepanomegas",
    source: "Arms of the Kingdom of Jerusalem.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_the_Kingdom_of_Jerusalem.svg",
    why: "Cross potent between four crosslets, or on argent.",
  },
  "kingdom:k_egypt": {
    src: a_heraldry_kingdom_k_egypt_webp,
    licence: "CC BY 3.0",
    artist: "Jarvisa",
    source: "Blason Seigneurs de Monceaux (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Monceaux_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_baghdad": {
    src: a_heraldry_kingdom_k_baghdad_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Philippe de Jonghe (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Philippe_de_Jonghe_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_mosul": {
    src: a_heraldry_kingdom_k_mosul_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Lézinnes (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_L%C3%A9zinnes_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_mardin": {
    src: a_heraldry_kingdom_k_mardin_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Louis Coroneles (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Louis_Coroneles_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "kingdom:k_azerbaijan": {
    src: a_heraldry_kingdom_k_azerbaijan_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empereur de Bodun (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empereur_de_Bodun_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Estremadura": {
    src: a_heraldry_duchy_duchy_of_estremadura_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Guillaume de Haer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_de_Haer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Portucale": {
    src: a_heraldry_duchy_duchy_of_portucale_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jarvisa",
    source: "Blason Hugues Beckars de Maizey.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hugues_Beckars_de_Maizey.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Galicia": {
    src: a_heraldry_duchy_duchy_of_galicia_webp,
    licence: "CC BY-SA 3.0",
    artist: "Heralder",
    source: "Coat of Arms of Galicia (Spain), 16th Century.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Galicia_(Spain),_16th_Century.svg",
    why: "Wikidata: historical state on the Iberian Peninsula (910–1126). Resolved from \"Duchy of Galicia\".",
  },
  "duchy:Duchy of Toledo": {
    src: a_heraldry_duchy_duchy_of_toledo_webp,
    licence: "CC BY-SA 3.0",
    artist: "Manassas~commonswiki",
    source: "Blason Espaulars de Cais.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Espaulars_de_Cais.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Castile": {
    src: a_heraldry_duchy_duchy_of_castile_webp,
    licence: "CC BY-SA 3.0",
    artist: "Heralder",
    source: "Royal Arms of Castille (1214-15th Century).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Royal_Arms_of_Castille_(1214-15th_Century).svg",
    why: "Wikidata: European sovereign state (1065–1230). Resolved from \"Duchy of Castile\".",
  },
  "duchy:Duchy of Catalonia": {
    src: a_heraldry_duchy_duchy_of_catalonia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Picquigny (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Picquigny_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Aragon": {
    src: a_heraldry_duchy_duchy_of_aragon_webp,
    licence: "Public domain",
    artist: "Anno16",
    source: "Blason ville fr Aragon (Aude).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_ville_fr_Aragon_(Aude).svg",
    why: "Wikidata: commune in Aude, France. Resolved from \"Duchy of Aragon\".",
  },
  "duchy:Duchy of Andalusia": {
    src: a_heraldry_duchy_duchy_of_andalusia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Garbenheim (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Garbenheim_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Marchena": {
    src: a_heraldry_duchy_duchy_of_marchena_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Sir Patri (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Sir_Patri_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Fez": {
    src: a_heraldry_duchy_duchy_of_fez_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kontributor 2K",
    source: "Blason comté de Fezensac.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_comt%C3%A9_de_Fezensac.svg",
    why: "Wikidata: countship. Resolved from \"Duchy of Fez\".",
  },
  "duchy:Duchy of Bejaia": {
    src: a_heraldry_duchy_duchy_of_bejaia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Groetswiin (Poméranie) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Groetswiin_(Pom%C3%A9ranie)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ifriqiya": {
    src: a_heraldry_duchy_duchy_of_ifriqiya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Raymond de Mareuil (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Raymond_de_Mareuil_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Marrakech": {
    src: a_heraldry_duchy_duchy_of_marrakech_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Vianden (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Vianden_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Alcida": {
    src: a_heraldry_duchy_duchy_of_alcida_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas Le Despencer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_Le_Despencer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tlemcen": {
    src: a_heraldry_duchy_duchy_of_tlemcen_webp,
    licence: "CC BY 3.0",
    artist: "Kaliforniyka",
    source: "Blason Guillaume FitzWarin (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_FitzWarin_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tripolitania": {
    src: a_heraldry_duchy_duchy_of_tripolitania_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Walpott de Bassenheim (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Walpott_de_Bassenheim_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of the Ile de France": {
    src: a_heraldry_duchy_duchy_of_the_ile_de_france_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Castelblanco (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Castelblanco_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:County of Anjou": {
    src: a_heraldry_duchy_county_of_anjou_webp,
    licence: "CC BY-SA 4.0",
    artist: "Spax89",
    source: "Blason de la ville d'Anjou (Isère).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_de_la_ville_d%27Anjou_(Is%C3%A8re).svg",
    why: "Wikidata: commune in Isère, France. Resolved from \"County of Anjou\".",
  },
  "duchy:County of Flanders": {
    src: a_heraldry_duchy_county_of_flanders_webp,
    licence: "CC0",
    artist: "Tom-L",
    source: "Arms of Flanders.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_Flanders.svg",
    why: "The black lion, borne by Baldwin IX.",
  },
  "duchy:Duchy of Brittany": {
    src: a_heraldry_duchy_duchy_of_brittany_webp,
    licence: "Public domain",
    artist: "Kontributor 2K",
    source: "Armoiries Bretagne - Arms of Brittany.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Armoiries_Bretagne_-_Arms_of_Brittany.svg",
    why: "Ermine plain, before the later quarterings. Public domain.",
  },
  "duchy:Duchy of Essex": {
    src: a_heraldry_duchy_duchy_of_essex_webp,
    licence: "CC BY-SA 3.0",
    artist: "User:MrWeeble",
    source: "Arms of Essex.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_Essex.svg",
    why: "Wikidata: ceremonial county in England (use Q21272241 for administrative non-metropolitan county). Resolved from \"Duchy of Essex\".",
  },
  "duchy:Duchy of Northumbria": {
    src: a_heraldry_duchy_duchy_of_northumbria_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Comtes fr Valentinois (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Comtes_fr_Valentinois_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Elmsett": {
    src: a_heraldry_duchy_duchy_of_elmsett_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Bettschau (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Bettschau_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Leinster": {
    src: a_heraldry_duchy_duchy_of_leinster_webp,
    licence: "CC BY-SA 4.0",
    artist: "Ssolbergj",
    source: "Coat of arms of Leinster.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Leinster.svg",
    why: "Wikidata: province in Ireland. Resolved from \"Duchy of Leinster\".",
  },
  "duchy:Duchy of Gascony": {
    src: a_heraldry_duchy_duchy_of_gascony_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kontributor 2K",
    source: "Blason comte fr Armagnac.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_comte_fr_Armagnac.svg",
    why: "Wikidata: medieval duchy of the Aquitaine region. Resolved from \"Duchy of Gascony\".",
  },
  "duchy:Duchy of Lothian": {
    src: a_heraldry_duchy_duchy_of_lothian_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Neydeck (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Neydeck_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Gulathing": {
    src: a_heraldry_duchy_duchy_of_gulathing_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empereur de Tricala (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empereur_de_Tricala_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Trondelag": {
    src: a_heraldry_duchy_duchy_of_trondelag_webp,
    licence: "Public domain",
    artist: "Spider",
    source: "Trøndelag våpen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Tr%C3%B8ndelag_v%C3%A5pen.svg",
    why: "Wikidata: county of Norway (2018–present). Resolved from \"Duchy of Trondelag\".",
  },
  "duchy:Duchy of Viken": {
    src: a_heraldry_duchy_duchy_of_viken_webp,
    licence: "Public domain",
    artist: "Viken fylkeskommune",
    source: "Viken våpen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Viken_v%C3%A5pen.svg",
    why: "Wikidata: former county of Norway (begin of 2020 ... end of 2023). Resolved from \"Duchy of Viken\".",
  },
  "duchy:Duchy of Uppland": {
    src: a_heraldry_duchy_duchy_of_uppland_webp,
    licence: "CC BY-SA 2.5",
    artist: "Lokal_Profil",
    source: "Uppland vapen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Uppland_vapen.svg",
    why: "Wikidata: province in Sweden. Resolved from \"Duchy of Uppland\".",
  },
  "duchy:Duchy of Vastergotland": {
    src: a_heraldry_duchy_duchy_of_vastergotland_webp,
    licence: "CC BY-SA 2.5",
    artist: "Lokal Profil",
    source: "Västergötland vapen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:V%C3%A4sterg%C3%B6tland_vapen.svg",
    why: "Wikidata: province in Sweden. Resolved from \"Duchy of Vastergotland\".",
  },
  "duchy:Duchy of Gotland": {
    src: a_heraldry_duchy_duchy_of_gotland_webp,
    licence: "CC BY-SA 2.5",
    artist: "Marmelad and Leonid 2",
    source: "Gotland vapen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Gotland_vapen.svg",
    why: "Wikidata: island and historical province in Sweden. Resolved from \"Duchy of Gotland\".",
  },
  "duchy:Duchy of Zealand": {
    src: a_heraldry_duchy_duchy_of_zealand_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Simon de Guntheim (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Simon_de_Guntheim_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Falund": {
    src: a_heraldry_duchy_duchy_of_falund_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Bradburne (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Bradburne_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Jutland": {
    src: a_heraldry_duchy_duchy_of_jutland_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Gérard de Jauche (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_G%C3%A9rard_de_Jauche_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Holstein": {
    src: a_heraldry_duchy_duchy_of_holstein_webp,
    licence: "CC BY-SA 3.0",
    artist: "Ipankonin",
    source: "Holstein Arms.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Holstein_Arms.svg",
    why: "The nettle leaf of Holstein.",
  },
  "duchy:Duchy of Lower Lorraine": {
    src: a_heraldry_duchy_duchy_of_lower_lorraine_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kontributor 2K",
    source: "Gules a fess argent.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Gules_a_fess_argent.svg",
    why: "Wikidata: duchy. Resolved from \"Duchy of Lower Lorraine\".",
  },
  "duchy:Duchy of Cranbach": {
    src: a_heraldry_duchy_duchy_of_cranbach_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Herbert de Liesvelt (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Herbert_de_Liesvelt_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Landgraviate of Alsace": {
    src: a_heraldry_duchy_landgraviate_of_alsace_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Dacre (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Dacre_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Bavaria": {
    src: a_heraldry_duchy_duchy_of_bavaria_webp,
    licence: "CC BY 3.0",
    artist: "Jarvisa",
    source: "Blason Oger V d'Anglure (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Oger_V_d%27Anglure_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Saxony": {
    src: a_heraldry_duchy_duchy_of_saxony_webp,
    licence: "CC BY-SA 4.0",
    artist: "MostEpic",
    source: "Arms of the house of Ascania (ancient).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_the_house_of_Ascania_(ancient).svg",
    why: "Ascanian Saxony with the crancelin; they held it from 1180.",
  },
  "duchy:Duchy of Saynfurt": {
    src: a_heraldry_duchy_duchy_of_saynfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Costin de Halmale (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Costin_de_Halmale_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:County of Burgundy": {
    src: a_heraldry_duchy_county_of_burgundy_webp,
    licence: "CC BY-SA 4.0",
    artist: "This vector image includes elements that have been taken or adapted from this file:",
    source: "Arms of County of Burgundy.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Arms_of_County_of_Burgundy.svg",
    why: "The Free County, not the duchy. A plain shield, not the collared version.",
  },
  "duchy:Duchy of Lyonnais": {
    src: a_heraldry_duchy_duchy_of_lyonnais_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hugues Anglesola (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hugues_Anglesola_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:County of Provence": {
    src: a_heraldry_duchy_county_of_provence_webp,
    licence: "CC BY-SA 3.0",
    artist: "Thom.lanaud",
    source: "Blason d'Aragon.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_d%27Aragon.svg",
    why: "Provence was held by a cadet Aragonese branch from 1166.",
  },
  "duchy:Duchy of Lobau": {
    src: a_heraldry_duchy_duchy_of_lobau_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean d'Erkentel-Argenteau (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_d%27Erkentel-Argenteau_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lombardy": {
    src: a_heraldry_duchy_duchy_of_lombardy_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jimmy44",
    source: "Blason Simon de Melun, seigneur de Vaux le Vicomte (Wijnbergen).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Simon_de_Melun,_seigneur_de_Vaux_le_Vicomte_(Wijnbergen).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tuscany": {
    src: a_heraldry_duchy_duchy_of_tuscany_webp,
    licence: "CC BY-SA 3.0",
    artist: "Alejandro Mery",
    source: "Coat of arms of Tuscany.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Tuscany.svg",
    why: "Wikidata: region of Italy. Resolved from \"Duchy of Tuscany\".",
  },
  "duchy:Judicate of Cagliari": {
    src: a_heraldry_duchy_judicate_of_cagliari_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Bogoria (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Bogoria_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Venetia": {
    src: a_heraldry_duchy_duchy_of_venetia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas de Morley (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_de_Morley_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Dalmatia": {
    src: a_heraldry_duchy_duchy_of_dalmatia_webp,
    licence: "CC0",
    artist: "Madboy74",
    source: "Coa Croatia Country Dalmatia History (without crown).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coa_Croatia_Country_Dalmatia_History_(without_crown).svg",
    why: "Wikidata: historical and cultural Croatian region. Resolved from \"Duchy of Dalmatia\".",
  },
  "duchy:Duchy of Crete": {
    src: a_heraldry_duchy_duchy_of_crete_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Stralendorff (Heinning) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Stralendorff_(Heinning)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Sicily": {
    src: a_heraldry_duchy_duchy_of_sicily_webp,
    licence: "Public domain",
    artist: "Teo.raff",
    source: "Coat of arms of Sicily.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Sicily.svg",
    why: "Wikidata: island in the Mediterranean, region of Italy. Resolved from \"Duchy of Sicily\".",
  },
  "duchy:Duchy of Bari": {
    src: a_heraldry_duchy_duchy_of_bari_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jacques d'Oedenheim (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jacques_d%27Oedenheim_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hungary": {
    src: a_heraldry_duchy_duchy_of_hungary_webp,
    licence: "Public domain",
    artist: "Madboy74",
    source: "Coa Hungary Country History István V (1239-1272).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coa_Hungary_Country_History_Istv%C3%A1n_V_(1239-1272).svg",
    why: "The same Arpad stripes; the duchy and the crown are the same house in 1212.",
  },
  "duchy:Duchy of Croatia": {
    src: a_heraldry_duchy_duchy_of_croatia_webp,
    licence: "Public domain",
    artist: "Haisollokopas",
    source: "Coat of arms of Croatia.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Croatia.svg",
    why: "Wikidata: country in Central Europe. Resolved from \"Duchy of Croatia\".",
  },
  "duchy:Duchy of Lesser Poland": {
    src: a_heraldry_duchy_duchy_of_lesser_poland_webp,
    licence: "Public domain",
    artist: "Bastianowa (Bastiana)",
    source: "POL województwo krakowskie IRP COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:POL_wojew%C3%B3dztwo_krakowskie_IRP_COA.svg",
    why: "Wikidata: historical region of Poland. Resolved from \"Duchy of Lesser Poland\".",
  },
  "duchy:Duchy of Greater Poland": {
    src: a_heraldry_duchy_duchy_of_greater_poland_webp,
    licence: "Public domain",
    artist: "Bastian (vector version)",
    source: "POL województwo wielkopolskie COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:POL_wojew%C3%B3dztwo_wielkopolskie_COA.svg",
    why: "Wikidata: historical Polish province. Resolved from \"Duchy of Greater Poland\".",
  },
  "duchy:Duchy of Pomerelia": {
    src: a_heraldry_duchy_duchy_of_pomerelia_webp,
    licence: "Public domain",
    artist: "Bastian (vector version)",
    source: "POL województwo pomorskie IRP COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:POL_wojew%C3%B3dztwo_pomorskie_IRP_COA.svg",
    why: "Wikidata: historic sub-region of Pomerania located in northern Poland. Resolved from \"Duchy of Pomerelia\".",
  },
  "duchy:Duchy of Lithuania": {
    src: a_heraldry_duchy_duchy_of_lithuania_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Wencelas de Hertoghe (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Wencelas_de_Hertoghe_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Livonia": {
    src: a_heraldry_duchy_duchy_of_livonia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Guillaume Bardolf (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_Bardolf_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Novgorod": {
    src: a_heraldry_duchy_duchy_of_novgorod_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Raymond de Roses (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Raymond_de_Roses_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Pskov": {
    src: a_heraldry_duchy_duchy_of_pskov_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Hastings (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Hastings_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Vladimir": {
    src: a_heraldry_duchy_duchy_of_vladimir_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Abraham Socha de Szczytno - Nalecz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Abraham_Socha_de_Szczytno_-_Nalecz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Moscow": {
    src: a_heraldry_duchy_duchy_of_moscow_webp,
    licence: "Public domain",
    artist: "Original Author: Vector-Images.com Converted to SVG by: Oren neu dag",
    source: "Coat of arms of Moscow.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Moscow.svg",
    why: "Wikidata: capital and most populous city of Russia. Resolved from \"Duchy of Moscow\".",
  },
  "duchy:Duchy of Kyiv": {
    src: a_heraldry_duchy_duchy_of_kyiv_webp,
    licence: "Public domain",
    artist: "Leonid76",
    source: "COA of Kyiv Kurovskyi.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:COA_of_Kyiv_Kurovskyi.svg",
    why: "Wikidata: capital and largest city of Ukraine. Resolved from \"Duchy of Kyiv\".",
  },
  "duchy:Duchy of Falkstein": {
    src: a_heraldry_duchy_duchy_of_falkstein_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henri Le Despencer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henri_Le_Despencer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Smolensk": {
    src: a_heraldry_duchy_duchy_of_smolensk_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ralph Greystoke (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ralph_Greystoke_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Polotsk": {
    src: a_heraldry_duchy_duchy_of_polotsk_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Blaisy (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Blaisy_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Halych": {
    src: a_heraldry_duchy_duchy_of_halych_webp,
    licence: "Public domain",
    artist: "Alex Tora or Alex K in Ukranian and Japanese wiki",
    source: "Alex K Halych.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Alex_K_Halych.svg",
    why: "Wikidata: state in Eastern Europe. Resolved from \"Duchy of Halych\".",
  },
  "duchy:Duchy of Volhynia": {
    src: a_heraldry_duchy_duchy_of_volhynia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Geisbusch (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Geisbusch_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tarnovo": {
    src: a_heraldry_duchy_duchy_of_tarnovo_webp,
    licence: "CC BY 3.0",
    artist: "Jarvisa",
    source: "Blason Jean de Poquières (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Poqui%C3%A8res_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Vidin": {
    src: a_heraldry_duchy_duchy_of_vidin_webp,
    licence: "CC BY-SA 3.0",
    artist: "Пакко",
    source: "Coat of arms of Vidin.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Vidin.svg",
    why: "Wikidata: city in Vidin municipality, Vidin oblast, Bulgaria. Resolved from \"Duchy of Vidin\".",
  },
  "duchy:Duchy of Kosovo": {
    src: a_heraldry_duchy_duchy_of_kosovo_webp,
    licence: "CC BY-SA 3.0",
    artist: "Manassas~commonswiki",
    source: "Blason Geoffroy de Neuville.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Geoffroy_de_Neuville.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Thrace": {
    src: a_heraldry_duchy_duchy_of_thrace_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jastrzemblec (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jastrzemblec_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lamos": {
    src: a_heraldry_duchy_duchy_of_lamos_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs d'Avelin (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_d%27Avelin_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ionia": {
    src: a_heraldry_duchy_duchy_of_ionia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Beaufort-sur-Meuse (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Beaufort-sur-Meuse_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Chaldia": {
    src: a_heraldry_duchy_duchy_of_chaldia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Florent de Bigard (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Florent_de_Bigard_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Paphlagonia": {
    src: a_heraldry_duchy_duchy_of_paphlagonia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Châtelain d'Amposta (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ch%C3%A2telain_d%27Amposta_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ikonion": {
    src: a_heraldry_duchy_duchy_of_ikonion_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason John Grey (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_John_Grey_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Sebasteia": {
    src: a_heraldry_duchy_duchy_of_sebasteia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Wake (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Wake_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ankyra": {
    src: a_heraldry_duchy_duchy_of_ankyra_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Evêché de Wurtzbourg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ev%C3%AAch%C3%A9_de_Wurtzbourg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Loritino": {
    src: a_heraldry_duchy_duchy_of_loritino_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ducs de Schweidnitz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ducs_de_Schweidnitz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Kartli": {
    src: a_heraldry_duchy_duchy_of_kartli_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ladron de Vilanova (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ladron_de_Vilanova_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Gesuella": {
    src: a_heraldry_duchy_duchy_of_gesuella_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Lucy de Cockermouth (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Lucy_de_Cockermouth_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Krosbor": {
    src: a_heraldry_duchy_duchy_of_krosbor_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Othon d'Arkel (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Othon_d%27Arkel_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Sougdaia": {
    src: a_heraldry_duchy_duchy_of_sougdaia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Karl Ulfssons (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Karl_Ulfssons_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lower Egypt": {
    src: a_heraldry_duchy_duchy_of_lower_egypt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ostoja - Sciborye (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ostoja_-_Sciborye_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Damascus": {
    src: a_heraldry_duchy_duchy_of_damascus_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hainaut moderne Cadet (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hainaut_moderne_Cadet_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Aleppo": {
    src: a_heraldry_duchy_duchy_of_aleppo_webp,
    licence: "Public domain",
    artist: "Vectored by Valentinys",
    source: "Coat of Arms of Aleppo.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Aleppo.svg",
    why: "Wikidata: city in Aleppo Governorate, Syria. Resolved from \"Duchy of Aleppo\".",
  },
  "duchy:Duchy of Judea": {
    src: a_heraldry_duchy_duchy_of_judea_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jarvisa",
    source: "Blason Aubert d'Ornes.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Aubert_d%27Ornes.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Iraq": {
    src: a_heraldry_duchy_duchy_of_iraq_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Clutinc (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Clutinc_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Basra": {
    src: a_heraldry_duchy_duchy_of_basra_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Veldenz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Veldenz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Jazira": {
    src: a_heraldry_duchy_duchy_of_jazira_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Sainte-Beuve (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Sainte-Beuve_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Amida": {
    src: a_heraldry_duchy_duchy_of_amida_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Renaud de Fauquemont (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Renaud_de_Fauquemont_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Azerbaijan": {
    src: a_heraldry_duchy_duchy_of_azerbaijan_webp,
    licence: "Public domain",
    artist: "Original: BetacommandBot Vector: Zscout370",
    source: "Emblem of Azerbaijan.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Emblem_of_Azerbaijan.svg",
    why: "Wikidata: country in the Caucasus in Eastern Europe and Western Asia. Resolved from \"Duchy of Azerbaijan\".",
  },
  "duchy:Duchy of Iceland": {
    src: a_heraldry_duchy_duchy_of_iceland_webp,
    licence: "Public domain",
    artist: "Rkt2312",
    source: "Coat of arms of Iceland.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Iceland.svg",
    why: "Wikidata: Nordic island country in the North Atlantic Ocean. Resolved from \"Duchy of Iceland\".",
  },
  "duchy:Duchy of Ansbach": {
    src: a_heraldry_duchy_duchy_of_ansbach_webp,
    licence: "Public domain",
    artist: "Jürgen Krause",
    source: "DEU Ansbach COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:DEU_Ansbach_COA.svg",
    why: "Wikidata: town in Bavaria, Germany. Resolved from \"Duchy of Ansbach\".",
  },
  "duchy:Duchy of Falkenau": {
    src: a_heraldry_duchy_duchy_of_falkenau_webp,
    licence: "CC BY 3.0",
    artist: "Andrew Pertsev",
    source: "Blason Guillaume Latimer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_Latimer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Haldor": {
    src: a_heraldry_duchy_duchy_of_haldor_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jacques d'Audley (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jacques_d%27Audley_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Dornburg": {
    src: a_heraldry_duchy_duchy_of_dornburg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Louis d'Etampes (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Louis_d%27Etampes_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hjelm": {
    src: a_heraldry_duchy_duchy_of_hjelm_webp,
    licence: "CC BY-SA 4.0",
    artist: "Thom.lanaud",
    source: "Blason famille de Reinach (ancien).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_famille_de_Reinach_(ancien).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tanum": {
    src: a_heraldry_duchy_duchy_of_tanum_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Bernard de Zedlitz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Bernard_de_Zedlitz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Sayn": {
    src: a_heraldry_duchy_duchy_of_sayn_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Nils Giädda (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Nils_Gi%C3%A4dda_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Kalden": {
    src: a_heraldry_duchy_duchy_of_kalden_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Richard Le Scrope (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Richard_Le_Scrope_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Borgund": {
    src: a_heraldry_duchy_duchy_of_borgund_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas Faucomberg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_Faucomberg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Arnsberg": {
    src: a_heraldry_duchy_duchy_of_arnsberg_webp,
    licence: "Public domain",
    artist: "SteveK",
    source: "DEU Arnsberg COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:DEU_Arnsberg_COA.svg",
    why: "Wikidata: town in North Rhine-Westphalia, Germany. Resolved from \"Duchy of Arnsberg\".",
  },
  "duchy:Duchy of Marbach": {
    src: a_heraldry_duchy_duchy_of_marbach_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Allo Nielsen (Rosencrantz) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Allo_Nielsen_(Rosencrantz)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Freiburg": {
    src: a_heraldry_duchy_duchy_of_freiburg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Antoine de Luna (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Antoine_de_Luna_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Heiligen": {
    src: a_heraldry_duchy_duchy_of_heiligen_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hinckaert, en Brabant (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hinckaert,_en_Brabant_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Nesje": {
    src: a_heraldry_duchy_duchy_of_nesje_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam es Fortia (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_es_Fortia_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Herse": {
    src: a_heraldry_duchy_duchy_of_herse_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Pierre Arnaut (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Pierre_Arnaut_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Rheinau": {
    src: a_heraldry_duchy_duchy_of_rheinau_webp,
    licence: "Public domain",
    artist: "Chris die Seele",
    source: "DEU Rheinau COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:DEU_Rheinau_COA.svg",
    why: "Wikidata: municipality in Baden-Württemberg, Germany. Resolved from \"Duchy of Rheinau\".",
  },
  "duchy:Duchy of Kirchberg": {
    src: a_heraldry_duchy_duchy_of_kirchberg_webp,
    licence: "Public domain",
    artist: "Taktaal",
    source: "Kirchberg SG-blazon.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Kirchberg_SG-blazon.svg",
    why: "Wikidata: municipality in the canton of St. Gallen, Switzerland. Resolved from \"Duchy of Kirchberg\".",
  },
  "duchy:Duchy of Stange": {
    src: a_heraldry_duchy_duchy_of_stange_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas Holland (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_Holland_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Waldeck": {
    src: a_heraldry_duchy_duchy_of_waldeck_webp,
    licence: "CC BY-SA 4.0",
    artist: "Glasshouse with elements by Sodacan, Tom-L and katepanomegas",
    source: "Coat of Arms of the Principality of Waldeck and Pyrmont.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_the_Principality_of_Waldeck_and_Pyrmont.svg",
    why: "Wikidata: former principality in Germany. Resolved from \"Duchy of Waldeck\".",
  },
  "duchy:Duchy of Bernau": {
    src: a_heraldry_duchy_duchy_of_bernau_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Adam de Kerkem (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Adam_de_Kerkem_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Elshausen": {
    src: a_heraldry_duchy_duchy_of_elshausen_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Maison de Preuilly (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Maison_de_Preuilly_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Vardal": {
    src: a_heraldry_duchy_duchy_of_vardal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Carniole (Selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Carniole_(Selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Schaum": {
    src: a_heraldry_duchy_duchy_of_schaum_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Bernard de Wiltberg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Bernard_de_Wiltberg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Falun": {
    src: a_heraldry_duchy_duchy_of_falun_webp,
    licence: "CC BY-SA 2.5",
    artist: "Lokal_Profil",
    source: "Falun vapen.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Falun_vapen.svg",
    why: "Wikidata: urban area in Falun Municipality, Sweden. Resolved from \"Duchy of Falun\".",
  },
  "duchy:Duchy of Kolding": {
    src: a_heraldry_duchy_duchy_of_kolding_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Etienne de Cosington (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Etienne_de_Cosington_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Landfeld": {
    src: a_heraldry_duchy_duchy_of_landfeld_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs de Pressigny (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Pressigny_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Fjaere": {
    src: a_heraldry_duchy_duchy_of_fjaere_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Eric Karlsson Örnfot (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Eric_Karlsson_%C3%96rnfot_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Schaumwalde": {
    src: a_heraldry_duchy_duchy_of_schaumwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henri Criel (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henri_Criel_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Bernheim": {
    src: a_heraldry_duchy_duchy_of_bernheim_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ducs de Mazovie (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ducs_de_Mazovie_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Iseneck": {
    src: a_heraldry_duchy_duchy_of_iseneck_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Maison d'Aumont (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Maison_d%27Aumont_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Weinthal": {
    src: a_heraldry_duchy_duchy_of_weinthal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Tozenbach (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Tozenbach_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Arnsbach": {
    src: a_heraldry_duchy_duchy_of_arnsbach_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Meinill (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Meinill_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Teckwalde": {
    src: a_heraldry_duchy_duchy_of_teckwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Albert de Mecklembourg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Albert_de_Mecklembourg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Steineck": {
    src: a_heraldry_duchy_duchy_of_steineck_webp,
    licence: "CC BY-SA 3.0",
    artist: "Gretaz",
    source: "Blason Hattstatt.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hattstatt.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Torpoy": {
    src: a_heraldry_duchy_duchy_of_torpoy_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs de Noyelles (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Noyelles_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Varness": {
    src: a_heraldry_duchy_duchy_of_varness_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Luna (Zaragoza) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Luna_(Zaragoza)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Fjaeoy": {
    src: a_heraldry_duchy_duchy_of_fjaeoy_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Constable royal anglais (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Constable_royal_anglais_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zellstein": {
    src: a_heraldry_duchy_duchy_of_zellstein_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Wauthier VI d'Enghien (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Wauthier_VI_d%27Enghien_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Heilstein": {
    src: a_heraldry_duchy_duchy_of_heilstein_webp,
    licence: "CC BY 3.0",
    artist: "Jarvisa",
    source: "Blason Seigneurs de Creseques (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Creseques_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Grafeck": {
    src: a_heraldry_duchy_duchy_of_grafeck_webp,
    licence: "CC BY-SA 3.0",
    artist: "Manassas~commonswiki",
    source: "Blason Ferry de Chardogne.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ferry_de_Chardogne.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zollrode": {
    src: a_heraldry_duchy_duchy_of_zollrode_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jimmy44",
    source: "Blason Adam III de Melun (Wijnbergen).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Adam_III_de_Melun_(Wijnbergen).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Rotheim": {
    src: a_heraldry_duchy_duchy_of_rotheim_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Othon de Zeschau (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Othon_de_Zeschau_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Skiholm": {
    src: a_heraldry_duchy_duchy_of_skiholm_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Kettil Jonsson (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Kettil_Jonsson_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Blankfeld": {
    src: a_heraldry_duchy_duchy_of_blankfeld_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Mauburin de Liniers (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Mauburin_de_Liniers_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ebersthal": {
    src: a_heraldry_duchy_duchy_of_ebersthal_webp,
    licence: "CC BY 3.0",
    artist: "Ludger1961",
    source: "Blason Albert Mourer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Albert_Mourer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Geldberg": {
    src: a_heraldry_duchy_duchy_of_geldberg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hannke Lymbecke (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hannke_Lymbecke_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Wolfberg": {
    src: a_heraldry_duchy_duchy_of_wolfberg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jelita (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jelita_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lichthal": {
    src: a_heraldry_duchy_duchy_of_lichthal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Connétablie d'Angleterre (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Conn%C3%A9tablie_d%27Angleterre_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Renness": {
    src: a_heraldry_duchy_duchy_of_renness_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thierry III Wassenaer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thierry_III_Wassenaer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Falkfurt": {
    src: a_heraldry_duchy_duchy_of_falkfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Perement (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Perement_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lichwalde": {
    src: a_heraldry_duchy_duchy_of_lichwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henry Preston (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henry_Preston_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Neuwalde": {
    src: a_heraldry_duchy_duchy_of_neuwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Guillaume de Hamal (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_de_Hamal_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Bregburg": {
    src: a_heraldry_duchy_duchy_of_bregburg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Lutzow (Leider) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Lutzow_(Leider)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Passwalde": {
    src: a_heraldry_duchy_duchy_of_passwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empire de Trébizonde (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empire_de_Tr%C3%A9bizonde_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Nordness": {
    src: a_heraldry_duchy_duchy_of_nordness_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Custine (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Custine_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Gutenthal": {
    src: a_heraldry_duchy_duchy_of_gutenthal_webp,
    licence: "Public domain",
    artist: "Chris die Seele",
    source: "DEU Gutenthal COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:DEU_Gutenthal_COA.svg",
    why: "Wikidata: Q66028679. Resolved from \"Duchy of Gutenthal\".",
  },
  "duchy:Duchy of Oldau": {
    src: a_heraldry_duchy_duchy_of_oldau_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Philippe de Borsele (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Philippe_de_Borsele_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hersfurt": {
    src: a_heraldry_duchy_duchy_of_hersfurt_webp,
    licence: "CC BY 3.0",
    artist: "Popvjpaqiaa999",
    source: "Blason Thierry de Brederode (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thierry_de_Brederode_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Passbach": {
    src: a_heraldry_duchy_duchy_of_passbach_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Miles Stapelton (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Miles_Stapelton_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Glenarm": {
    src: a_heraldry_duchy_duchy_of_glenarm_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Magnus Hackensson (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Magnus_Hackensson_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Oberdorf": {
    src: a_heraldry_duchy_duchy_of_oberdorf_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Nassau-Dietz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Nassau-Dietz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lichdorf": {
    src: a_heraldry_duchy_duchy_of_lichdorf_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs de Villiers (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Villiers_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Beilthal": {
    src: a_heraldry_duchy_duchy_of_beilthal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Philippe Bryan (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Philippe_Bryan_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ardgour": {
    src: a_heraldry_duchy_duchy_of_ardgour_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Pierre Swinski de Rypin (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Pierre_Swinski_de_Rypin_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ansberg": {
    src: a_heraldry_duchy_duchy_of_ansberg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Bengt Bogh (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Bengt_Bogh_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Wolfbach": {
    src: a_heraldry_duchy_duchy_of_wolfbach_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Lambert d'Ouppeye (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Lambert_d%27Ouppeye_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Elsheim": {
    src: a_heraldry_duchy_duchy_of_elsheim_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Brisegaut de Coëmes (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Brisegaut_de_Co%C3%ABmes_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Geldburg": {
    src: a_heraldry_duchy_duchy_of_geldburg_webp,
    licence: "CC BY 3.0",
    artist: "Newm30",
    source: "Blason Walter Halyburton (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Walter_Halyburton_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Freithal": {
    src: a_heraldry_duchy_duchy_of_freithal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Pierre Jourdain d'Urriés (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Pierre_Jourdain_d%27Urri%C3%A9s_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Arnsthal": {
    src: a_heraldry_duchy_duchy_of_arnsthal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Christophe Parsberg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Christophe_Parsberg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Dunollie": {
    src: a_heraldry_duchy_duchy_of_dunollie_webp,
    licence: "CC BY-SA 3.0",
    artist: "Puck04",
    source: "Blason Conrad de Hattstatt.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Conrad_de_Hattstatt.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Srem": {
    src: a_heraldry_duchy_duchy_of_srem_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Fierabras de Vertain (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Fierabras_de_Vertain_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lobwalde": {
    src: a_heraldry_duchy_duchy_of_lobwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs de Frankenstein (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Frankenstein_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hallberg": {
    src: a_heraldry_duchy_duchy_of_hallberg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Zypen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Zypen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Nesfjord": {
    src: a_heraldry_duchy_duchy_of_nesfjord_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Craigie (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Craigie_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Cranheim": {
    src: a_heraldry_duchy_duchy_of_cranheim_webp,
    licence: "CC BY 3.0",
    artist: "Thom.lanaud",
    source: "Blason Seigneurs de Brimeu (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_de_Brimeu_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Arnsfurt": {
    src: a_heraldry_duchy_duchy_of_arnsfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Sibert de Selbach (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Sibert_de_Selbach_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Freifurt": {
    src: a_heraldry_duchy_duchy_of_freifurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam es Urriés (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_es_Urri%C3%A9s_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Schaumfurt": {
    src: a_heraldry_duchy_duchy_of_schaumfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Robert de Willoughby (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Robert_de_Willoughby_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Bielsk": {
    src: a_heraldry_duchy_duchy_of_bielsk_webp,
    licence: "Public domain",
    artist: "Jacek FH",
    source: "POL gmina Bielsk COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:POL_gmina_Bielsk_COA.svg",
    why: "Wikidata: village in Masovian, Poland. Resolved from \"Duchy of Bielsk\".",
  },
  "duchy:Duchy of Cranhausen": {
    src: a_heraldry_duchy_duchy_of_cranhausen_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas Trevet (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_Trevet_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Cranwalde": {
    src: a_heraldry_duchy_duchy_of_cranwalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Othon de Sliven (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Othon_de_Sliven_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Dieswalde": {
    src: a_heraldry_duchy_duchy_of_dieswalde_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Strasz de Bialaczow - Odrowaz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Strasz_de_Bialaczow_-_Odrowaz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Gutenfurt": {
    src: a_heraldry_duchy_duchy_of_gutenfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas d'Ufford (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_d%27Ufford_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Eicheim": {
    src: a_heraldry_duchy_duchy_of_eicheim_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ramold de Gorynia (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ramold_de_Gorynia_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hallheim": {
    src: a_heraldry_duchy_duchy_of_hallheim_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Leliwa (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Leliwa_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Heilbach": {
    src: a_heraldry_duchy_duchy_of_heilbach_webp,
    licence: "Public domain",
    artist: "Chris die Seele",
    source: "DEU Heilbach COA.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:DEU_Heilbach_COA.svg",
    why: "Wikidata: municipality of Germany. Resolved from \"Duchy of Heilbach\".",
  },
  "duchy:Duchy of Kesteven": {
    src: a_heraldry_duchy_duchy_of_kesteven_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Royaume de Danemark (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Royaume_de_Danemark_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hallfeld": {
    src: a_heraldry_duchy_duchy_of_hallfeld_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Versailles (de Melun) (Wijnbergen).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Versailles_(de_Melun)_(Wijnbergen).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Aubigny": {
    src: a_heraldry_duchy_duchy_of_aubigny_webp,
    licence: "Public domain",
    artist: "Syryatsu",
    source: "Blason comte fr Gueldre.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_comte_fr_Gueldre.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hohfurt": {
    src: a_heraldry_duchy_duchy_of_hohfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Devereux (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Devereux_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Wolfrode": {
    src: a_heraldry_duchy_duchy_of_wolfrode_webp,
    licence: "CC BY 3.0",
    artist: "Biplanjaune",
    source: "Blason Bourgogne-Brabant (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Bourgogne-Brabant_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ansthal": {
    src: a_heraldry_duchy_duchy_of_ansthal_webp,
    licence: "CC BY 3.0",
    artist: "Ludger1961",
    source: "Blason Waichingen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Waichingen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Schaumdorf": {
    src: a_heraldry_duchy_duchy_of_schaumdorf_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Pilik, Palatin de Varsovie (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Pilik,_Palatin_de_Varsovie_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lobhausen": {
    src: a_heraldry_duchy_duchy_of_lobhausen_webp,
    licence: "CC BY-SA 3.0",
    artist: "Manassas~commonswiki",
    source: "Blason Robert de Baissy.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Robert_de_Baissy.svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Andros": {
    src: a_heraldry_duchy_duchy_of_andros_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Durrenstein (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Durrenstein_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Sarno": {
    src: a_heraldry_duchy_duchy_of_sarno_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Stubenberg (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Stubenberg_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Montaigu": {
    src: a_heraldry_duchy_duchy_of_montaigu_webp,
    licence: "Public domain",
    artist: "Syryatsu",
    source: "Blason ville fr Montaigu (Jura).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_ville_fr_Montaigu_(Jura).svg",
    why: "Wikidata: commune in Jura, France. Resolved from \"Duchy of Montaigu\".",
  },
  "duchy:Duchy of Geldeck": {
    src: a_heraldry_duchy_duchy_of_geldeck_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hart (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hart_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Somogy": {
    src: a_heraldry_duchy_duchy_of_somogy_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas Erskine (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_Erskine_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Naupaktos": {
    src: a_heraldry_duchy_duchy_of_naupaktos_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam Pelisson (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_Pelisson_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Roththal": {
    src: a_heraldry_duchy_duchy_of_roththal_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Mol (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Mol_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Isernia": {
    src: a_heraldry_duchy_duchy_of_isernia_webp,
    licence: "CC BY-SA 4.0",
    artist: "Ddurbmonnejg",
    source: "Isernia-Stemma.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Isernia-Stemma.svg",
    why: "Wikidata: Italian comune. Resolved from \"Duchy of Isernia\".",
  },
  "duchy:Duchy of Bernrode": {
    src: a_heraldry_duchy_duchy_of_bernrode_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ogonczyk (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ogonczyk_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Conza": {
    src: a_heraldry_duchy_duchy_of_conza_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Prawda (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Prawda_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Gomhely": {
    src: a_heraldry_duchy_duchy_of_gomhely_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Yvan de Korczak (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Yvan_de_Korczak_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Miedgrad": {
    src: a_heraldry_duchy_duchy_of_miedgrad_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Bielik, Kornicz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Bielik,_Kornicz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Buonalbergo": {
    src: a_heraldry_duchy_duchy_of_buonalbergo_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Buzewoy (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Buzewoy_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zbarsk": {
    src: a_heraldry_duchy_duchy_of_zbarsk_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Kralic (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Kralic_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Turyn": {
    src: a_heraldry_duchy_duchy_of_turyn_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean de Valecow (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_de_Valecow_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Marsico": {
    src: a_heraldry_duchy_duchy_of_marsico_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Uulric Swaef (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Uulric_Swaef_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Lesina": {
    src: a_heraldry_duchy_duchy_of_lesina_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hermann Putbus (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hermann_Putbus_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Montoro": {
    src: a_heraldry_duchy_duchy_of_montoro_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Liechtenstein (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Liechtenstein_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Avelago": {
    src: a_heraldry_duchy_duchy_of_avelago_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Paeffenrode (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Paeffenrode_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Eichfurt": {
    src: a_heraldry_duchy_duchy_of_eichfurt_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Plessen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Plessen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ilbira": {
    src: a_heraldry_duchy_duchy_of_ilbira_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Voss (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Voss_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Rayyaya": {
    src: a_heraldry_duchy_duchy_of_rayyaya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Cortenbach (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Cortenbach_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Steinrode": {
    src: a_heraldry_duchy_duchy_of_steinrode_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empereur de Bodun (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empereur_de_Bodun_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Muntiyya": {
    src: a_heraldry_duchy_duchy_of_muntiyya_webp,
    licence: "CC BY 3.0",
    artist: "Andrew Pertsev",
    source: "Blason Guillaume Latimer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_Latimer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Kastamon": {
    src: a_heraldry_duchy_duchy_of_kastamon_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Nassau-Dietz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Nassau-Dietz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zollburg": {
    src: a_heraldry_duchy_duchy_of_zollburg_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Tozenbach (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Tozenbach_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Rundisa": {
    src: a_heraldry_duchy_duchy_of_rundisa_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Cortenbach (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Cortenbach_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Madinira": {
    src: a_heraldry_duchy_duchy_of_madinira_webp,
    licence: "CC BY 3.0",
    artist: "Jarvisa",
    source: "Blason Oger V d'Anglure (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Oger_V_d%27Anglure_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Nablus": {
    src: a_heraldry_duchy_duchy_of_nablus_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ducs de Schweidnitz (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ducs_de_Schweidnitz_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Jayida": {
    src: a_heraldry_duchy_duchy_of_jayida_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Costin de Halmale (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Costin_de_Halmale_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zawat": {
    src: a_heraldry_duchy_duchy_of_zawat_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Voss (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Voss_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Kiutahia": {
    src: a_heraldry_duchy_duchy_of_kiutahia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Ogonczyk (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Ogonczyk_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ubbira": {
    src: a_heraldry_duchy_duchy_of_ubbira_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Zypen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Zypen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Qabrisa": {
    src: a_heraldry_duchy_duchy_of_qabrisa_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henri de Welchenhausen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henri_de_Welchenhausen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Qasruna": {
    src: a_heraldry_duchy_duchy_of_qasruna_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason fam uk Wake (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Wake_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hisnaya": {
    src: a_heraldry_duchy_duchy_of_hisnaya_webp,
    licence: "CC BY 3.0",
    artist: "Popvjpaqiaa999",
    source: "Blason Thierry de Brederode (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thierry_de_Brederode_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Marqiyya": {
    src: a_heraldry_duchy_duchy_of_marqiyya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hugues Anglesola (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hugues_Anglesola_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Shaubak": {
    src: a_heraldry_duchy_duchy_of_shaubak_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Durrenstein (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Durrenstein_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Wadiyya": {
    src: a_heraldry_duchy_duchy_of_wadiyya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Sir Patri (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Sir_Patri_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Miloba": {
    src: a_heraldry_duchy_duchy_of_miloba_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Moltke (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Moltke_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Hierhisar": {
    src: a_heraldry_duchy_duchy_of_hierhisar_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Simon Grauss (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Simon_Grauss_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Muntaya": {
    src: a_heraldry_duchy_duchy_of_muntaya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Eric Karlsson Örnfot (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Eric_Karlsson_%C3%96rnfot_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Qabrira": {
    src: a_heraldry_duchy_duchy_of_qabrira_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Florent de Bigard (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Florent_de_Bigard_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Attaliye": {
    src: a_heraldry_duchy_duchy_of_attaliye_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Othon de Zeschau (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Othon_de_Zeschau_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Garnaya": {
    src: a_heraldry_duchy_duchy_of_garnaya_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Lézinnes (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_L%C3%A9zinnes_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Nibira": {
    src: a_heraldry_duchy_duchy_of_nibira_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Thomas d'Ufford (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Thomas_d%27Ufford_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Zawula": {
    src: a_heraldry_duchy_duchy_of_zawula_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jean Pilik, Palatin de Varsovie (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jean_Pilik,_Palatin_de_Varsovie_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Tralldere": {
    src: a_heraldry_duchy_duchy_of_tralldere_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Jelita (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Jelita_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Rayyat": {
    src: a_heraldry_duchy_duchy_of_rayyat_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Henri de Welchenhausen (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Henri_de_Welchenhausen_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Qabrat": {
    src: a_heraldry_duchy_duchy_of_qabrat_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Groetswiin (Poméranie) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Groetswiin_(Pom%C3%A9ranie)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Ikoneli": {
    src: a_heraldry_duchy_duchy_of_ikoneli_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Luna (Zaragoza) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Luna_(Zaragoza)_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Firrana": {
    src: a_heraldry_duchy_duchy_of_firrana_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Hart (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Hart_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Kastamdere": {
    src: a_heraldry_duchy_duchy_of_kastamdere_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Guillaume de Haer (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Guillaume_de_Haer_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Mileli": {
    src: a_heraldry_duchy_duchy_of_mileli_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Robert VI d'Estouteville (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Robert_VI_d%27Estouteville_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "duchy:Duchy of Choniye": {
    src: a_heraldry_duchy_duchy_of_choniye_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Seigneurs d'Avelin (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Seigneurs_d%27Avelin_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "empire:e_britannia": {
    src: a_heraldry_empire_e_britannia_webp,
    licence: "CC BY-SA 4.0",
    artist: "Sodacan; NsMn; Kaliforniyka",
    source: "Quartered from: Royal Arms of England (1198-1340).svg; Coat of arms of the Lordship of Ireland.svg; Royal Arms of the Kingdom of Scotland.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Royal_Arms_of_England_(1154-1189).svg",
    why: "Empire of Britannia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_england, k_ireland, k_scotland), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_francia": {
    src: a_heraldry_empire_e_francia_webp,
    licence: "CC BY-SA 3.0",
    artist: "Kontributor 2K; You may select the license of your choice.",
    source: "Quartered from: Blason pays fr France ancien.svg; Blason Languedoc.svg; Blason de l'Aquitaine et de la Guyenne.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Grand_Royal_Coat_of_Arms_of_France_%26_Navarre.svg",
    why: "Empire of Francia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_france, k_occitania, k_aquitaine), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_hispania": {
    src: a_heraldry_empire_e_hispania_webp,
    licence: "CC BY-SA 4.0",
    artist: "FDRMRZUSA (talk · contribs). See sourced file for original author.; Heralder; Tom Lemmens",
    source: "Quartered from: Flag of the Kingdom of Portugal (1185–1248).svg; Arms of León.svg; Arms of Castile.svg; Coat of Arms of the Kingdom of Navarre.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Brabant-Limbourg_(selon_Gelre).svg",
    why: "Empire of Hispania never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_portugal, k_leon, k_castile, k_navarre), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_germania": {
    src: a_heraldry_empire_e_germania_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Robert VI d'Estouteville (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Robert_VI_d%27Estouteville_(selon_Gelre).svg",
    why: "From a 13th-century armorial roll. This title is invented, so there is no coat of its own; a real medieval shield stands in.",
  },
  "empire:e_italia": {
    src: a_heraldry_empire_e_italia_webp,
    licence: "CC BY-SA 3.0",
    artist: "Jimmy44; Gambo7; Cageteen",
    source: "Quartered from: Blason Henri de Welchenhausen (selon Gelre).svg; Blason Hutin de Vermelles (selon Gelre).svg; CoA Pontifical States 02.svg; Armoiries Manfred de Sicile.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Pentz_(selon_Gelre).svg",
    why: "Empire of Italia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_italy, k_venice, k_papal, k_sicily), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_scandinavia": {
    src: a_heraldry_empire_e_scandinavia_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Quartered from: Blason Norvège ancien.svg; Blason Tover (selon Gelre).svg; Blason Danemark ancien.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Norv%C3%A8ge_ancien.svg",
    why: "Empire of Scandinavia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_norway, k_sweden, k_denmark), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_carpathia": {
    src: a_heraldry_empire_e_carpathia_webp,
    licence: "CC BY-SA 4.0",
    artist: "Madboy74; Kingscrow",
    source: "Quartered from: Coa Hungary Country History István V (1239-1272).svg; Herb pol.svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Duch%C3%A9_de_Limbourg_(selon_Gelre).svg",
    why: "Empire of Carpathia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_hungary, k_poland), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_rus": {
    src: a_heraldry_empire_e_rus_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Quartered from: Blason fam uk Ros (selon Gelre).svg; Blason Jean de Liebenstein (selon Gelre).svg; Blason Waleran de Fauquemont (selon Gelre).svg; Blason Murray (Moray) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_fam_uk_Hylton_(selon_Gelre).svg",
    why: "Empire of Rus never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_novgorod, k_vladimir, k_kyiv, k_galicia), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_byzantium": {
    src: a_heraldry_empire_e_byzantium_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Blason Empire latin de Constantinople (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Empire_latin_de_Constantinople_(selon_Gelre).svg",
    why: "In 1212 Constantinople was held by the Latin Empire, founded in the sack of 1204. That is who actually sat there, and unlike the Byzantines they bore arms. The Palaiologan tetragrammatic cross people picture postdates 1261.",
  },
  "empire:e_maghreb": {
    src: a_heraldry_empire_e_maghreb_webp,
    licence: "CC BY 3.0",
    artist: "Jimmy44",
    source: "Quartered from: Blason Franck de Borsele (selon Gelre).svg; Blason Houweningen (selon Gelre).svg; Blason Jean de Halmale (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Simon_de_Lalaing_(selon_Gelre).svg",
    why: "Empire of the Maghreb never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_morocco, k_tlemcen, k_ifriqiya), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_arabia": {
    src: a_heraldry_empire_e_arabia_webp,
    licence: "CC BY-SA 4.0",
    artist: "Thom.lanaud; HeralderCross by Katepanomegas; Jarvisa; Jimmy44",
    source: "Quartered from: Blason Bohémond VI d'Antioche.svg; Arms of the Kingdom of Jerusalem.svg; Blason Seigneurs de Monceaux (selon Gelre).svg; Blason Philippe de Jonghe (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Blason_Simon_Grauss_(selon_Gelre).svg",
    why: "Empire of Arabia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_antioch, k_jerusalem, k_egypt, k_baghdad), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
  "empire:e_anatolia": {
    src: a_heraldry_empire_e_anatolia_webp,
    licence: "Public domain / CC BY 3.0",
    artist: "Simon.eller; Jimmy44",
    source: "Quartered from: Wappen at rum.svg; Blason Spontin (Beaufort) (selon Gelre).svg",
    sourceUrl: "https://commons.wikimedia.org/wiki/File:Wappen_at_rum.svg",
    why: "Empire of Anatolia never existed, so it has no arms of its own. This quarters the crowns that answer to it here (k_rum, k_cilicia), which is how a herald would have combined them, and fills a square opening exactly as a shield cannot.",
  },
};

/** World-map village markers, smallest settlement first. */
export const VILLAGE_TIER_ART: string[] = [
  a_village_tiers_tier_1_webp,
  a_village_tiers_tier_2_webp,
  a_village_tiers_tier_3_webp,
  a_village_tiers_tier_4_webp,
  a_village_tiers_tier_5_webp,
  a_village_tiers_tier_6_webp,
  a_village_tiers_tier_7_webp,
];

/** The same seven rungs built in the Arabic style, for Islamic realms. */
export const VILLAGE_TIER_ART_ARABIC: string[] = [
  a_village_tiers_tier_arabic_1_webp,
  a_village_tiers_tier_arabic_2_webp,
  a_village_tiers_tier_arabic_3_webp,
  a_village_tiers_tier_arabic_4_webp,
  a_village_tiers_tier_arabic_5_webp,
  a_village_tiers_tier_arabic_6_webp,
  a_village_tiers_tier_arabic_7_webp,
];

/**
 * Points at which a village earns the next marker.
 *
 * A fully maxed village is worth 14,421. Because the points curve is
 * superlinear, thresholds spaced evenly in points would bunch every real
 * village at the bottom, so these are spaced to land evenly in *build
 * level* instead: roughly L1-2, L3-4, L5-7, L8-10, L11-14, L15-20, L21+.
 *
 * Purely cosmetic - tune freely. See documentation/12-progression-scoring.md.
 */
export const VILLAGE_TIER_THRESHOLDS = [100, 300, 800, 1800, 3800, 7500] as const;

/** 1-7. */
export function villageTierForPoints(points: number): number {
  let tier = 1;
  for (const threshold of VILLAGE_TIER_THRESHOLDS) {
    if (points >= threshold) tier++;
  }
  return tier;
}

export function villageTierArt(points: number): string {
  return VILLAGE_TIER_ART[villageTierForPoints(points) - 1] ?? VILLAGE_TIER_ART[0];
}

/** Parked artwork, processed to apps/web/src/assets/art/units-parked/ but
 * not bundled: Militia.
 * Add the unit to UNIT_CARDS in tools/process-art.mjs and re-run to use one.
 */
export const PARKED_UNIT_ART = ["militia"] as const;
